import { http, baseURL } from './client'
import type {
  AcquirerOut,
  AcquirerTerminalOut,
  AdIntegrationOut,
  AdIntegrationRunOut,
  AdIntegrationUpdate,
  AdminOut,
  AdminSectionOut,
  AuditLogOut,
  AuthEventOut,
  AuthSourceStat,
  AutopayDisableRequest,
  AutopayEnableRequest,
  AutopayOut,
  BalanceTransactionOut,
  CacheCategoryStatsOut,
  CacheHealthOut,
  CacheInvalidateResult,
  CacheKeysPage,
  CacheStatusOut,
  CacheTTLUpdate,
  CacheTarget,
  CacheTargetsOut,
  CacheWarmupReportOut,
  CacheWarmupResultOut,
  CurrencyConvertRequest,
  CurrencyConvertResponse,
  CurrencyRateOut,
  CurrencyRateSyncRequest,
  CurrencyRateSyncResultOut,
  CurrencyRateUpdate,
  DashboardClientsStats,
  DashboardEsimStats,
  DashboardRevenueStats,
  DashboardStats,
  DashboardChartListOut,
  DashboardChartsOut,
  DashboardDevicesStats,
  DashboardSmsStats,
  DashboardLayoutIn,
  DashboardLayoutOut,
  DashboardTrafficStats,
  DiscountOut,
  EmergencyCandidatesParams,
  EmergencyCandidatesResponse,
  EmergencyJob,
  EmergencyJobDetail,
  EmergencyReplaceRequest,
  ESimEventOut,
  ESimFiltersMeta,
  ESimIssueOut,
  ESimIssueRequest,
  ESimOut,
  ESimProviderSyncResult,
  ESimReportExportRequest,
  ESimReportMetaOut,
  ESimReportPreviewOut,
  ESimReportPreviewRequest,
  ESimReturnRequest,
  ESimReturnResult,
  ESimSearchFacets,
  GlobalSearchOut,
  ESimExpiryNotifySchedulerCreate,
  ESimExpiryNotifySchedulerOut,
  ESimExpiryNotifySchedulerRunnerStatus,
  ESimExpiryNotifySchedulerUpdate,
  ESimSyncSchedulerCreate,
  ESimSyncSchedulerOut,
  ESimSyncSchedulerRunnerStatus,
  ESimSyncSchedulerUpdate,
  ClientSurveyListOut,
  ClientSurveyOut,
  CostIntegrationCostCreate,
  CostIntegrationCostCreateOut,
  CostIntegrationSettingsUpdate,
  CostIntegrationStatusOut,
  CostIntegrationSyncOut,
  ExpenseCreate,
  ExpenseOut,
  ExpenseUpdate,
  FinanceExpenseCreate,
  FinanceExpenseOut,
  FinanceExpenseUpdate,
  FinancePartnerCreate,
  FinancePartnerOut,
  FinancePartnerUpdate,
  FinanceReportOut,
  FinanceReportRunnerStatus,
  FinanceIntegrationPollerOut,
  FinanceIntegrationPollerUpdate,
  FinanceReportSchedulerOut,
  FinanceReportSchedulerUpdate,
  FinanceStatsOut,
  FinanceStatsSettingsOut,
  FinanceStatsSettingsUpdate,
  MarketFinanceOut,
  MarketFinanceRunOut,
  MarketFinanceUpdate,
  ServicePriceCreate,
  ServicePriceOut,
  ServicePriceUpdate,
  LostESimAssignRequest,
  LostESimItem,
  LostESimReactivateRequest,
  PaymentBackfillEvent,
  PaymentBackfillPreview,
  PaymentBackfillRequest,
  PaymentOut,
  PaymentSourceStat,
  PaymentStatusSchedulerCreate,
  PaymentStatusSchedulerOut,
  PaymentStatusSchedulerRunnerStatus,
  PaymentStatusSchedulerUpdate,
  PlanCompareFiltersIn,
  PlanCompareResponse,
  PlanCompareStateIn,
  PlanCompareStateResponse,
  PlanCountryHideResponse,
  PlanCountryRestoreResponse,
  PlanCountryVisibilityRequest,
  PlanDetailOut,
  PlanDuplicatesHideResponse,
  PlanDuplicatesMode,
  PlanHiddenCountryOut,
  PlanMarkupApplyRequest,
  PlanMarkupApplyResponse,
  PlanOut,
  PlanRegionOut,
  PlanReserveResponse,
  PlanStateStatsOut,
  PlanUniquePublishRequest,
  PlanUniquePublishResponse,
  NewPlanState,
  FallbackProvidersOut,
  FallbackProvidersUpdate,
  MarketingXlsxApplyResponse,
  PopularCountriesOut,
  ProviderAccountOut,
  ProviderBalanceSchedulerCreate,
  ProviderBalanceSchedulerOut,
  ProviderBalanceSchedulerRunnerStatus,
  ProviderBalanceSchedulerUpdate,
  ProviderOut,
  ProviderPlanOut,
  ReportExportRequest,
  ReportKindsOut,
  ReportMetaOut,
  ReportPreviewOut,
  ReportAnalyticsMetaOut,
  ReportAnalyticsOut,
  ReportAnalyticsRequest,
  ReportChartCreate,
  ReportChartDataOut,
  ReportChartListOut,
  ReportChartOut,
  ReportChartUpdate,
  ReportPreviewRequest,
  ReportTemplateCreate,
  ReportTemplateListOut,
  ReportTemplateOut,
  ReportTemplateUpdate,
  SMSCountryCreate,
  SMSCountryOut,
  SMSCountryUpdate,
  SMSProviderCreate,
  SMSProviderOut,
  SMSProviderSyncAllResult,
  SMSProviderSyncResult,
  SMSProviderTestPreviewResponse,
  SMSProviderTestRequest,
  SMSProviderUpdate,
  SMSSendResultOut,
  SMSTemplateCreate,
  SMSTemplateOut,
  SMSTemplatePreviewRequest,
  SMSTemplatePreviewResponse,
  SMSTemplateTestRequest,
  SMSTemplateUpdate,
  SupportedSMSProvider,
  SMTPSendResultOut,
  SMTPServerCreate,
  SMTPServerOut,
  SMTPServerTestRequest,
  SMTPServerUpdate,
  SMTPTemplateCreate,
  SMTPTemplateOut,
  SMTPTemplatePreviewRequest,
  SMTPTemplatePreviewResponse,
  SMTPTemplateTestRequest,
  SMTPTemplateUpdate,
  SystemSettingOut,
  TelegramAlertTestRequest,
  TelegramAlertTestResult,
  TelegramGatewayAccountCreate,
  TelegramGatewayAccountOut,
  TelegramGatewayAccountUpdate,
  TelegramGatewaySyncResult,
  TelegramGatewayTestRequest,
  TelegramGatewayTestResult,
  TokenPair,
  TopupMarkupConfigIn,
  TopupMarkupConfigOut,
  TopupMarkupPreviewIn,
  TopupMarkupPreviewOut,
  TopupProvidersOut,
  TopupProvidersUpdate,
  UserAttachReferralRequest,
  UserDetail,
  UserFiltersMeta,
  UserHardDeleteRequest,
  UserHardDeleteResponse,
  UserLinkPhoneRequest,
  UserLinkTelegramRequest,
  UserLinkTelegramResponse,
  UserListItem,
  UserSearchFacets,
  UserSetEmailRequest,
  UserSetPhoneRequest,
  UserSetTelegramRequest,
  UserSetTelegramResponse,
  UserVerifyEmailResponse,
} from './types'

// ---- AUTH ----
export const authApi = {
  loginPassword: (username: string, password: string) =>
    http.post<TokenPair>('/auth/login', { username, password }).then((r) => r.data),
  loginTelegram: (initData: string) =>
    http.post<TokenPair>('/auth/telegram', { init_data: initData }).then((r) => r.data),
  refresh: (refresh_token: string) =>
    http.post<TokenPair>('/auth/refresh', { refresh_token }).then((r) => r.data),
  me: () => http.get<AdminOut>('/auth/me').then((r) => r.data),
}

// ---- DASHBOARD ----
//
// Главная страница админки. Кроме «короткой» сводки `/dashboard/`
// (старая реализация) есть три тематических модуля — «Выручка»,
// «Клиенты», «eSIM». Каждый модуль независимый и возвращает свою
// агрегированную картину; на стороне backend'а стоит in-process
// TTL-кэш (~3 секунды), а параметр `force=true` сбрасывает его —
// это используется кнопкой «Обновить» в SPA: жмём — гарантированно
// видим свежие цифры; не жмём (автообновление) — попадаем в кэш и
// не нагружаем БД.

export const dashboardApi = {
  stats: (force = false) =>
    http
      .get<DashboardStats>('/dashboard/', { params: { force } })
      .then((r) => r.data),
  revenue: (force = false) =>
    http
      .get<DashboardRevenueStats>('/dashboard/revenue', { params: { force } })
      .then((r) => r.data),
  clients: (force = false) =>
    http
      .get<DashboardClientsStats>('/dashboard/clients', { params: { force } })
      .then((r) => r.data),
  esim: (force = false) =>
    http
      .get<DashboardEsimStats>('/dashboard/esim', { params: { force } })
      .then((r) => r.data),
  // Модуль «Трафик»: потребление данных eSIM (суммы/бакеты/топы/динамика).
  // 404 возможен в окне деплоя (старый backend ещё без ручки) — подавляем
  // глобальный тост, DashboardView покажет per-модульную ошибку.
  traffic: (force = false) =>
    http
      .get<DashboardTrafficStats>('/dashboard/traffic', {
        params: { force },
        skipErrorToast: (status: number) => status === 404,
      })
      .then((r) => r.data),
  // Модуль «Устройства»: на чём стоят наши eSIM (покрытие + разрезы по
  // ОС/вендору/модели/источнику). 404 подавляем по той же причине, что и
  // у «Трафика».
  devices: (force = false) =>
    http
      .get<DashboardDevicesStats>('/dashboard/devices', {
        params: { force },
        skipErrorToast: (status: number) => status === 404,
      })
      .then((r) => r.data),
  // Модуль «SMS выручка»: одноразовые номера — деньги, успешность,
  // балансы кабинетов. 404 подавляем по той же причине, что и у «Трафика».
  sms: (force = false) =>
    http
      .get<DashboardSmsStats>('/dashboard/sms', {
        params: { force },
        skipErrorToast: (status: number) => status === 404,
      })
      .then((r) => r.data),
  // Графики из «Отчётов» на главной: закреплённые (`on_dashboard`) плюс
  // разложенные по разделам персональной раскладки (`ids`). Одним
  // запросом на всю страницу: за каждой плиткой стоит прогон отчёта, и
  // дробить их по разделам — значит платить временем открытия главной.
  //
  // Каждая плитка считается отдельно, поэтому ручка отвечает 200 даже
  // когда часть графиков сломана — ошибка приезжает внутри своей плитки.
  //
  // 404 возможен в окне деплоя (старый backend), 403 — если подраздел
  // `dashboard:charts` админу не выдан: и то и другое просто скрывает
  // блок, красный тост поверх работающего дашборда тут лишний.
  charts: (ids: number[] = []) =>
    http
      .get<DashboardChartsOut>('/dashboard/charts', {
        params: ids.length ? { ids } : undefined,
        timeout: 120_000,
        skipErrorToast: (status: number) => status === 404 || status === 403,
      })
      .then((r) => r.data),

  // Справочник для пикера «добавить график в раздел»: те же графики, но
  // без данных — считать двадцать отчётов ради выпадающего списка незачем.
  availableCharts: (search?: string) =>
    http
      .get<DashboardChartListOut>('/dashboard/charts/available', {
        params: { search: search || undefined },
        skipErrorToast: (status: number) => status === 404 || status === 403,
      })
      .then((r) => r.data),

  // ---- Персональная раскладка главной ----
  //
  // Порядок разделов, скрытые разделы, плитки метрик и графики по
  // разделам. Читает любой с доступом к «Дашборду», пишет — тот, кому
  // выдан подраздел `dashboard:layout`.
  //
  // `is_custom: false` = раскладку не собирали: рисуем дефолт из
  // `components/dashboard/layout.ts`. 404/403 тут — не ошибка (старый
  // backend / нет прав), дашборд просто остаётся дефолтным.
  layout: () =>
    http
      .get<DashboardLayoutOut>('/dashboard/layout', {
        skipErrorToast: (status: number) => status === 404 || status === 403,
      })
      .then((r) => r.data),
  saveLayout: (body: DashboardLayoutIn) =>
    http.put<DashboardLayoutOut>('/dashboard/layout', body).then((r) => r.data),
  // Сброс = удаление строки: дефолт живёт в коде фронта и приезжает
  // вместе с новыми модулями, а застывшая копия дефолта — нет.
  resetLayout: () => http.delete('/dashboard/layout'),
}

// ---- USERS ----
export const usersApi = {
  // Страница списка клиентов. Фильтры — query-параметрами (см. зависимость
  // `user_filters` в api/admin/routers/users.py); массивы уходят повтором
  // имени параметра, см. paramsSerializer в client.ts. Старые вызовы с
  // `{ q, status }` продолжают работать: backend принимает оба псевдонима.
  list: (params: Record<string, unknown> = {}) =>
    http.get<UserListItem[]>('/users/', { params }).then((r) => r.data),
  // Те же фильтры, что и у list (без limit/offset) — backend вернёт
  // количество клиентов под фильтр, из него UI считает число страниц.
  count: (params: Record<string, unknown> = {}) =>
    http.get<number>('/users/count', { params }).then((r) => r.data),
  // Разбивка регистраций и входов по каналам за период: сколько человек
  // завелось и вошло из приложения, с сайта и из Telegram.
  authSources: (params: { since?: string; until?: string } = {}) =>
    http
      .get<AuthSourceStat[]>('/users/auth-sources', {
        params: cleanParams(params as Record<string, unknown>),
      })
      .then((r) => r.data),
  // Справочники для панели фильтров: статусы и состояния с русскими
  // подписями, способы регистрации, валюты, страны телефонов, домены
  // e-mail, быстрые фильтры. Тянется один раз при открытии раздела.
  // «Мягкая» ручка: без справочников панель теряет только выпадающие
  // списки, поэтому красный тост поверх работающего списка тут лишний.
  filtersMeta: () =>
    http
      .get<UserFiltersMeta>('/users/filters/meta', { skipErrorToast: true })
      .then((r) => r.data),
  // Счётчики «сколько найдётся, если выбрать этот пункт» при ТЕКУЩИХ
  // фильтрах. Параметры те же, что у list. Тоже «мягкая»: не доехала
  // (старый admin-API) — панель покажет статические count из справочника.
  facets: (params: Record<string, unknown> = {}) =>
    http
      .get<UserSearchFacets>('/users/facets', { params, skipErrorToast: true })
      .then((r) => r.data),
  get: (id: number) => http.get<UserDetail>(`/users/${id}`).then((r) => r.data),
  // Лукап по id для пикеров: «нет такого клиента» там обычный исход
  // поиска, поэтому 404 → null и без тоста.
  findById: (id: number) =>
    http
      .get<UserDetail>(`/users/${id}`, {
        skipErrorToast: (status: number) => status === 404,
      })
      .then((r) => r.data)
      .catch((e) => {
        if (e?.response?.status === 404) return null
        throw e
      }),
  payments: (id: number) =>
    http.get<PaymentOut[]>(`/users/${id}/payments`).then((r) => r.data),
  // История регистраций и входов клиента, свежие сверху. Колонкой
  // last_login_at такой список не заменить: она хранит одно значение.
  authEvents: (id: number, limit = 50) =>
    http
      .get<AuthEventOut[]>(`/users/${id}/auth-events`, { params: { limit } })
      .then((r) => r.data),
  esims: (id: number) =>
    http.get<ESimOut[]>(`/users/${id}/esims`).then((r) => r.data),
  // Выпуск eSIM клиенту (раздел «Тарифы» → 🎁). Ответ приходит сразу,
  // а eSIM выпускает воркер клиентского API — прогресс в esimIssue.
  issueEsim: (id: number, body: ESimIssueRequest) =>
    http.post<ESimIssueOut>(`/users/${id}/esims`, body).then((r) => r.data),
  // Окно выпуска опрашивает это раз в несколько секунд и ошибки показывает
  // у себя: тост на каждый опрос завалил бы экран. Путь — под вкладкой
  // карточки «eSIM», без неё 403.
  esimIssue: (id: number, paymentId: number) =>
    http
      .get<ESimIssueOut>(`/users/${id}/esims/issue/${paymentId}`, {
        skipErrorToast: true,
      })
      .then((r) => r.data),
  discounts: (id: number, includeInactive = false) =>
    http
      .get<DiscountOut[]>(`/users/${id}/discounts`, {
        params: { include_inactive: includeInactive },
      })
      .then((r) => r.data),
  balanceTxs: (id: number, wallet?: 'main' | 'referral') =>
    http
      .get<BalanceTransactionOut[]>(`/users/${id}/balance/transactions`, {
        params: wallet ? { wallet } : {},
      })
      .then((r) => r.data),
  topup: (id: number, amount: number, reason?: string) =>
    http
      .post<BalanceTransactionOut>(`/users/${id}/balance/topup`, { amount, reason })
      .then((r) => r.data),
  adjust: (id: number, delta: number, description?: string, allowNegative = false) =>
    http
      .post<BalanceTransactionOut>(`/users/${id}/balance/adjust`, {
        delta,
        description,
        allow_negative: allowNegative,
      })
      .then((r) => r.data),
  // Реферальный кошелёк (``app_user.referral_balance``). Backend различает
  // его от основного через query/body параметр ``wallet`` или отдельный
  // путь ``/referral-balance``. Здесь используем отдельные эндпоинты —
  // так трасса в admin_audit_log читается без лишних условий.
  referralTopup: (id: number, amount: number, reason?: string) =>
    http
      .post<BalanceTransactionOut>(`/users/${id}/referral-balance/topup`, {
        amount,
        reason,
      })
      .then((r) => r.data),
  referralAdjust: (
    id: number,
    delta: number,
    description?: string,
    allowNegative = false,
  ) =>
    http
      .post<BalanceTransactionOut>(`/users/${id}/referral-balance/adjust`, {
        delta,
        description,
        allow_negative: allowNegative,
      })
      .then((r) => r.data),
  create: (data: { email: string; password: string; login?: string; telegram_user_id?: number }) =>
    http.post<UserDetail>('/users/', data).then((r) => r.data),
  update: (id: number, data: Partial<UserDetail>) =>
    http.patch<UserDetail>(`/users/${id}`, data).then((r) => r.data),
  delete: (id: number) => http.delete(`/users/${id}`),
  // Полное удаление клиента из БД со всеми связями. Backend требует
  // обязательное «защитное» слово ровно «Подтверждаю» (с заглавной П) —
  // иначе вернёт 400. Возвращает счётчики удалённых строк по таблицам,
  // которые UI показывает в тосте после успешного удаления. Эта ручка
  // деструктивна и недоступна для soft-deleted-клиента (backend выдаст
  // 404, если ``app_user`` уже удалён через soft-delete и его строка
  // была физически вычищена ранее).
  hardDelete: (id: number, body: UserHardDeleteRequest) =>
    http
      .post<UserHardDeleteResponse>(`/users/${id}/hard-delete`, body)
      .then((r) => r.data),
  // Вручную перевести пользователя из 'unconfirmed' в 'active' и
  // зафиксировать email_verified_at. Используется кнопкой
  // «Подтвердить email» в UserDetailView. Backend идемпотентен: для
  // уже active-пользователя просто докинет email_verified_at, если
  // он был null.
  verifyEmail: (id: number) =>
    http
      .post<UserVerifyEmailResponse>(`/users/${id}/verify-email`)
      .then((r) => r.data),
  // Принудительная смена email клиенту от имени админа (без письма-
  // подтверждения). Используется саппортом: «клиент позвонил, проверили,
  // меняем». Audit-лог сохранит и старый, и новый адрес в payload.
  setEmail: (id: number, body: UserSetEmailRequest) =>
    http
      .post<UserDetail>(`/users/${id}/set-email`, body)
      .then((r) => r.data),
  // Привязать телефон клиенту с пустым ``phone`` (без SMS-кода —
  // ответственность на админе). Если у клиента уже есть phone —
  // backend вернёт 409 ``phone_already_linked``: сначала отвяжите.
  linkPhone: (id: number, body: UserLinkPhoneRequest) =>
    http
      .post<UserDetail>(`/users/${id}/link-phone`, body)
      .then((r) => r.data),
  // Жёстко выставить телефон клиенту: и привязка, и смена. Без SMS-кода —
  // ответственность на админе. В отличие от ``linkPhone`` допускает
  // ``phone IS NOT NULL`` и просто перезаписывает поле. Идемпотентно
  // (новый номер == текущий → no-op без audit-лога). Audit-лог:
  // ``user.set_phone`` с ``old_phone``/``new_phone``.
  setPhone: (id: number, body: UserSetPhoneRequest) =>
    http
      .post<UserDetail>(`/users/${id}/set-phone`, body)
      .then((r) => r.data),
  // Жёстко отвязать телефон (``phone = NULL``, ``phone_country_code = NULL``,
  // ``phone_verified_at = NULL``). Идемпотентно — повторный вызов на
  // уже-пустом phone не пишет audit-лога. ⚠ Если phone был
  // единственным каналом входа (у синтетического email-а ``*@phone.local``)
  // клиент потеряет доступ; решение об этом — на админе.
  unlinkPhone: (id: number) =>
    http
      .post<UserDetail>(`/users/${id}/unlink-phone`)
      .then((r) => r.data),
  // Привязать ``telegram_user_id`` к аккаунту с возможным merge-ом.
  // Если этот telegram-id уже занят другим клиентом, backend по
  // умолчанию вернёт 409 — нужно дополнительно передать
  // ``allow_merge=true`` И ``confirmation="Подтверждаю"`` (UI собирает
  // их в модалке). При merge backend перенесёт eSIM/payment/balance
  // с back-аккаунта на текущий и hard-delete-нет back. Счётчики
  // переноса возвращаются в ``merged`` ответа.
  linkTelegram: (id: number, body: UserLinkTelegramRequest) =>
    http
      .post<UserLinkTelegramResponse>(`/users/${id}/link-telegram`, body)
      .then((r) => r.data),
  // Жёстко привязать ``telegram_user_id`` с «переносом»: если id уже
  // привязан к другому клиенту — backend отвяжет его от того аккаунта
  // (тот НЕ удаляется и НЕ мерджится, все его eSIM/платежи/баланс
  // остаются) и привяжет к текущему. Уже стоящий у клиента другой id
  // перезаписывается. Идемпотентно (тот же id → no-op). Audit-лог:
  // ``user.set_telegram`` с old/new id и ``unlinked_from_user_id``.
  setTelegram: (id: number, body: UserSetTelegramRequest) =>
    http
      .post<UserSetTelegramResponse>(`/users/${id}/set-telegram`, body)
      .then((r) => r.data),

  // ---- REFERRALS (кого пригласил этот клиент) ----
  //
  // Привязка реферала проставляет `referral.referred_by_id = id` —
  // т.е. «текущий клиент пригласил выбранного». Реферала выбираем из
  // обычного поиска по клиентам (usersApi.list({ q })), поэтому
  // отдельной поисковой ручки тут нет.
  listReferrals: (id: number, params: { limit?: number; offset?: number } = {}) =>
    http
      .get<UserListItem[]>(`/users/${id}/referrals`, { params })
      .then((r) => r.data),
  attachReferral: (id: number, body: UserAttachReferralRequest) =>
    http
      .post<UserListItem>(`/users/${id}/referrals`, body)
      .then((r) => r.data),
  detachReferral: (id: number, referralUserId: number) =>
    http.delete(`/users/${id}/referrals/${referralUserId}`),

  // ---- AUTOPAY (см. api/admin/routers/users.py + db/models/autopay.py) ----
  //
  // Активировать новый autopay из админки нельзя — у нас нет card-data
  // клиента. Эти ручки только для управления уже сохранённым
  // ``rebill_id`` (выключить / включить обратно / удалить).
  listAutopays: (id: number, includeInactive = true) =>
    http
      .get<AutopayOut[]>(`/users/${id}/autopay`, {
        params: { include_inactive: includeInactive },
      })
      .then((r) => r.data),
  // Мягкое отключение: ``is_active=false``, ``rebill_id`` остаётся —
  // можно вернуть кнопкой "Включить".
  disableAutopay: (
    user_id: number,
    autopay_id: number,
    body: AutopayDisableRequest = {},
  ) =>
    http
      .post<AutopayOut>(
        `/users/${user_id}/autopay/${autopay_id}/disable`,
        body,
      )
      .then((r) => r.data),
  // Повторная активация ранее отключённой autopay-записи. Бэкенд
  // вернёт 409, если у строки нет ``rebill_id``.
  enableAutopay: (
    user_id: number,
    autopay_id: number,
    body: AutopayEnableRequest = {},
  ) =>
    http
      .post<AutopayOut>(
        `/users/${user_id}/autopay/${autopay_id}/enable`,
        body,
      )
      .then((r) => r.data),
  // Жёстко удалить запись (необратимо, ``rebill_id`` стирается).
  deleteAutopay: (user_id: number, autopay_id: number) =>
    http.delete(`/users/${user_id}/autopay/${autopay_id}`),
}

// ---- ACQUIRERS ----
export const acquirersApi = {
  list: () => http.get<AcquirerOut[]>('/acquirers/').then((r) => r.data),
  create: (data: {
    code: string
    display_name: string
    is_active?: boolean
    is_visible?: boolean
  }) => http.post<AcquirerOut>('/acquirers/', data).then((r) => r.data),
  update: (id: number, data: Partial<AcquirerOut>) =>
    http.patch<AcquirerOut>(`/acquirers/${id}`, data).then((r) => r.data),
  // hard=true — физическое удаление. Если есть связанные платежи и/или
  // payment_webhook, backend вернёт 409 с подсказкой «передайте force=true».
  // force=true — оставить payment-записи как аудит, но обнулить их FK,
  // и снести payment_webhook журналы. Платежи в «живом» статусе
  // блокируют даже force-delete (422).
  delete: (id: number, hard = false, force = false) =>
    http.delete(`/acquirers/${id}`, { params: { hard, force } }),
  terminals: (id: number) =>
    http.get<AcquirerTerminalOut[]>(`/acquirers/${id}/terminals`).then((r) => r.data),
  createTerminal: (id: number, data: any) =>
    http.post<AcquirerTerminalOut>(`/acquirers/${id}/terminals`, data).then((r) => r.data),
  updateTerminal: (id: number, data: any) =>
    http.patch<AcquirerTerminalOut>(`/acquirers/terminals/${id}`, data).then((r) => r.data),
  // hard=true → физическое удаление терминала. Бэкенд вернёт 409, если
  // у терминала есть привязанные платежи (тогда фронт предложит soft
  // ИЛИ hard+force).
  // force=true — снять защиту: платежи в терминальных статусах
  // (CONFIRMED/REJECTED/…) останутся в БД, FK acquirer_terminal_id
  // обнулится; платежи в активных статусах всё равно блокируют (422).
  deleteTerminal: (id: number, hard = false, force = false) =>
    http.delete(`/acquirers/terminals/${id}`, { params: { hard, force } }),
  // Сколько активных терминалов осталось у эквайринга. Если в UI
  // удаляемый терминал последний (count <= 1), показываем диалог
  // «введите ПОДТВЕРЖДАЮ».
  activeTerminalsCount: (acquirerId: number) =>
    http
      .get<number>(`/acquirers/${acquirerId}/terminals/active-count`)
      .then((r) => r.data),
}

// ---- PROVIDERS ----
export interface ProviderAccountSyncResult {
  account: ProviderAccountOut
  provider_created: boolean
  account_created: boolean
  pulled_from_api: boolean
  external_status: string | null
  note: string | null
  // Сырой ответ SmartCard `GET /account`, как пришёл от агрегатора.
  // Полезен для диагностики «balance=0»: показываем админу, что именно
  // SmartCard прислал, без догадок и парсинга на нашей стороне.
  api_response: Record<string, unknown> | null
}
export interface ProviderAccountSyncAllResult {
  total: number
  succeeded: number
  failed: number
  skipped: number
  results: ProviderAccountSyncResult[]
}
export interface SupportedProvider {
  code: string
  display_name: string
  default_base_url: string
  description: string
}
export const providersApi = {
  list: () => http.get<ProviderOut[]>('/providers/').then((r) => r.data),
  supportedCodes: () =>
    http.get<SupportedProvider[]>('/providers/supported-codes').then((r) => r.data),
  create: (data: {
    code: string
    display_name: string
    base_url?: string
    is_active?: boolean
    is_visible?: boolean
  }) => http.post<ProviderOut>('/providers/', data).then((r) => r.data),
  update: (id: number, data: Partial<ProviderOut>) =>
    http.patch<ProviderOut>(`/providers/${id}`, data).then((r) => r.data),
  // cascade=true имеет смысл только с hard=true: backend сначала попытается
  // удалить все esim_provider_account, потом сам провайдер.
  delete: (id: number, hard = false, cascade = false) =>
    http.delete(`/providers/${id}`, { params: { hard, cascade } }),
  accounts: (id: number) =>
    http.get<ProviderAccountOut[]>(`/providers/${id}/accounts`).then((r) => r.data),
  createAccount: (id: number, data: any) =>
    http.post<ProviderAccountOut>(`/providers/${id}/accounts`, data).then((r) => r.data),
  updateAccount: (id: number, data: any) =>
    http.patch<ProviderAccountOut>(`/providers/accounts/${id}`, data).then((r) => r.data),
  deleteAccount: (id: number, hard = false) =>
    http.delete(`/providers/accounts/${id}`, { params: { hard } }),
  // Сколько активных аккаунтов осталось у провайдера. UI использует
  // это, чтобы перед DELETE последнего аккаунта показать диалог
  // «введите ПОДТВЕРЖДАЮ».
  activeAccountsCount: (providerId: number) =>
    http
      .get<number>(`/providers/${providerId}/accounts/active-count`)
      .then((r) => r.data),
  // Пересинхронизировать существующий account_id (сейчас работает только
  // для SmartCard, и только если в аккаунте лежат inline-креды).
  syncAccount: (account_id: number) =>
    http
      .post<ProviderAccountSyncResult>(`/providers/accounts/${account_id}/sync`)
      .then((r) => r.data),
  // Одним запросом обойти все активные SmartCard-аккаунты и обновить у каждого
  // balance/credit_limit/status из /account. Возвращает агрегированный
  // результат + список per-account.
  syncAllAccounts: () =>
    http
      .post<ProviderAccountSyncAllResult>('/providers/accounts/sync-all')
      .then((r) => r.data),
}

// ---- PLANS ----
export interface PlansListParams {
  include_inactive?: boolean
  q?: string
  type?: string
  category?: string
  is_visible?: boolean
  // true — только «в запасе»; «просто скрытые» — is_visible=false и
  // is_reserve=false.
  is_reserve?: boolean
  is_active?: boolean
  // ISO-2 код страны: оставить тарифы, в которые входит эта страна
  // (одно-страновые по plan_country/region_code и региональные по
  // provider_plan.countries_included).
  country?: string
  // Тип активации: тарифы с пакетом такого типа; 0 — тип неизвестен у всех.
  active_type?: number
  // Тарифы с активным пакетом провайдера; 0 — без единого активного пакета.
  provider_id?: number
  // Только тарифы в выдаче без запаса у других агрегаторов.
  no_backup?: boolean
  limit?: number
  offset?: number
}

// Хелпер: axios превращает `undefined`-параметры в строки `"undefined"`
// у некоторых сериализаторов; явный clean делает запрос предсказуемым,
// заодно убирает пустую строку из q (иначе фильтр включится в ILIKE и
// вернёт `name ILIKE '%%'` — это всегда true, но лишний LIKE-скан).
function cleanParams(p: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {}
  for (const [k, v] of Object.entries(p)) {
    if (v === undefined || v === null) continue
    if (typeof v === 'string' && v.trim() === '') continue
    out[k] = v
  }
  return out
}

export const plansApi = {
  list: (params: PlansListParams | boolean = {}) => {
    // Сохраняем обратную совместимость: раньше `plansApi.list(true)` —
    // include_inactive=true. Теперь принимаем либо bool, либо полный params.
    const p: PlansListParams =
      typeof params === 'boolean' ? { include_inactive: params } : params
    return http
      .get<PlanOut[]>('/plans/', { params: cleanParams(p as Record<string, unknown>) })
      .then((r) => r.data)
  },
  count: (params: PlansListParams = {}) =>
    http
      .get<number>('/plans/count', {
        params: cleanParams(params as Record<string, unknown>),
      })
      .then((r) => r.data),
  // «В выдаче / в запасе / скрыт» всего и по провайдерам — при тех же
  // фильтрах, что у списка; состояние и провайдер бэк не принимает.
  stateStats: (params: PlansListParams = {}) =>
    http
      .get<PlanStateStatsOut>('/plans/state-stats', {
        params: cleanParams(params as Record<string, unknown>),
      })
      .then((r) => r.data),
  // Лукап одного тарифа по id (для прямого ввода plan_id в формах
  // и скриптах админки). Возвращает 404, если тарифа нет.
  get: (id: number) => http.get<PlanOut>(`/plans/${id}`).then((r) => r.data),
  // Полная карточка тарифа из БД (все поля + страны/операторы) для
  // модалки «ℹ️». Тот же эндпоинт, что и `get`, но типизирован шире.
  getDetail: (id: number) =>
    http.get<PlanDetailOut>(`/plans/${id}`).then((r) => r.data),
  create: (data: any) => http.post<PlanOut>('/plans/', data).then((r) => r.data),
  update: (id: number, data: any) =>
    http.patch<PlanOut>(`/plans/${id}`, data).then((r) => r.data),
  delete: (id: number) => http.delete(`/plans/${id}`),
  providerPlans: (id: number) =>
    http.get<ProviderPlanOut[]>(`/plans/${id}/provider-plans`).then((r) => r.data),
  upsertProviderPlan: (data: any) =>
    http.post<ProviderPlanOut>('/plans/provider-plans', data).then((r) => r.data),
  // Не-стримовый парсинг каталога (кнопка в «eSIM провайдеры»).
  // keep_markup_on_cost_change / dry_run / new_plan_state — те же флаги,
  // что у стрима: см. streamParsePlans ниже.
  parse: (
    provider_account_id: number,
    create_missing_internal = true,
    opts: {
      keep_markup_on_cost_change?: boolean
      dry_run?: boolean
      new_plan_state?: NewPlanState
    } = {},
  ) =>
    http
      .post<{
        fetched: number
        inserted: number
        updated: number
        skipped: number
        errors: string[]
        cost_shift_applied: number
        cost_shift_skipped: number
        dry_run: boolean
        new_plan_state: NewPlanState
        created_on_sale: number
        created_reserve: number
        created_hidden: number
      }>('/plans/parse', {
        provider_account_id,
        create_missing_internal,
        keep_markup_on_cost_change: opts.keep_markup_on_cost_change ?? false,
        dry_run: opts.dry_run ?? false,
        new_plan_state: opts.new_plan_state ?? 'on_sale',
      })
      .then((r) => r.data),
  // Скрипт «Рассчитать наценку». dry_run=true → backend ничего не пишет,
  // только возвращает раскладку (используется для preview-окна перед
  // нажатием «Применить»). dry_run=false → пишет в БД и вешает запись
  // в admin_audit_log.
  applyMarkup: (body: PlanMarkupApplyRequest) =>
    http
      .post<PlanMarkupApplyResponse>('/plans/markup/apply', body)
      .then((r) => r.data),
  // Скрипт «Таблица маркетолога»: загрузка xlsx с ID тарифа / Статус /
  // рек. розн. ценой. dry_run=true — только сверка с БД, dry_run=false —
  // пишет retail_price и is_visible. Content-Type сбрасываем, чтобы
  // браузер сам проставил multipart boundary (инстанс axios по умолчанию
  // шлёт application/json).
  applyMarketingXlsx: (file: File, dryRun: boolean) => {
    const fd = new FormData()
    fd.append('file', file)
    return http
      .post<MarketingXlsxApplyResponse>('/plans/marketing-xlsx', fd, {
        params: { dry_run: dryRun },
        timeout: 180_000,
        headers: { 'Content-Type': false as unknown as string },
      })
      .then((r) => r.data)
  },
  // Скрипт «Дубликаты тарифов»: из одинаковых тарифов всех провайдеров
  // оставить на витрине один. dry_run=true — только группы, dry_run=false —
  // скрывает остальные (is_visible=false), с toReserve — сразу в запас;
  // включать скрипт не умеет.
  hideDuplicates: (mode: PlanDuplicatesMode, dryRun: boolean, toReserve = true) =>
    http
      .post<PlanDuplicatesHideResponse>(
        '/plans/duplicates/hide',
        { mode, dry_run: dryRun, to_reserve: toReserve },
        { timeout: 120_000 },
      )
      .then((r) => r.data),
  // Скрипт «Дубликаты → в запас»: скрытые тарифы, у которых есть
  // одинаковый тариф в выдаче, перевести в запас. Только добавляет в запас.
  reserveDuplicates: (dryRun: boolean) =>
    http
      .post<PlanReserveResponse>(
        '/plans/duplicates/reserve',
        { dry_run: dryRun },
        { timeout: 120_000 },
      )
      .then((r) => r.data),
  // Скрипт «Уникальные тарифы → в выдачу»: тарифы в запасе и скрытые,
  // которые дают стране новый вариант «срок × объём», вывести в выдачу.
  // Настоящий прогон — только с plan_ids из предпросмотра; только включает.
  publishUnique: (body: PlanUniquePublishRequest) =>
    http
      .post<PlanUniquePublishResponse>('/plans/unique/publish', body, {
        timeout: 120_000,
      })
      .then((r) => r.data),
  // Вкладка «Сравнение»: группы одинаковых тарифов всех агрегаторов во
  // всех трёх состояниях, с закупкой и пометкой выгодного. Ничего не меняет.
  compareSearch: (filters: PlanCompareFiltersIn, toReserve = true) =>
    http
      .post<PlanCompareResponse>(
        '/plans/compare/search',
        { filters, to_reserve: toReserve },
        { timeout: 120_000 },
      )
      .then((r) => r.data),
  // Авто-переключение: выгодный по закупке — в выдачу, остальные дубликаты
  // группы — в запас (toReserve) или под скрытие. Тариф без наценки в
  // выдачу не выводится — он приходит в needs_markup. Сначала dry_run.
  compareApply: (filters: PlanCompareFiltersIn, dryRun: boolean, toReserve = true) =>
    http
      .post<PlanCompareResponse>(
        '/plans/compare/apply',
        { filters, dry_run: dryRun, to_reserve: toReserve },
        { timeout: 180_000 },
      )
      .then((r) => r.data),
  // Ручное переключение состояний группы одной транзакцией: «этот в
  // выдачу, остальные в запас».
  compareState: (changes: PlanCompareStateIn[]) =>
    http
      .post<PlanCompareStateResponse>('/plans/compare/state', { changes })
      .then((r) => r.data),
  // Скрипт «Страна: убрать из выдачи / вернуть в выдачу». Убрать — скрыть
  // все тарифы страницы в выдаче и запомнить их; вернуть — включить ровно
  // запомненные. dry_run=true — только посчитать.
  hiddenCountries: () =>
    http.get<PlanHiddenCountryOut[]>('/plans/hidden-countries').then((r) => r.data),
  hideCountry: (body: PlanCountryVisibilityRequest) =>
    http
      .post<PlanCountryHideResponse>('/plans/hidden-countries/hide', body, {
        timeout: 120_000,
      })
      .then((r) => r.data),
  restoreCountry: (body: PlanCountryVisibilityRequest) =>
    http
      .post<PlanCountryRestoreResponse>('/plans/hidden-countries/restore', body, {
        timeout: 120_000,
      })
      .then((r) => r.data),
  // Все region_code, по которым в БД есть тарифы (в любом состоянии).
  regions: () => http.get<PlanRegionOut[]>('/plans/regions').then((r) => r.data),
}

// ---- POPULAR COUNTRIES (раздел «Тарифы → Фронтенд») ----
//
// Управление упорядоченным списком «популярных стран», который потом
// отдаётся клиентской витрине (GET /tariffs/popular-countries).
// Хранится в system_setting (ключ client.popular_countries) одной
// CSV-строкой — отдельной таблицы/миграции нет.
export const popularCountriesApi = {
  // Текущий сохранённый список (в порядке вывода).
  get: () =>
    http
      .get<PopularCountriesOut>('/popular-countries/')
      .then((r) => r.data),
  // Перезаписать список. Порядок важен (его задаёт админ
  // перетаскиванием). Backend нормализует коды (trim/upper/dedup).
  save: (codes: string[]) =>
    http
      .put<PopularCountriesOut>('/popular-countries/', { codes })
      .then((r) => r.data),
  // Топ стран по продажам eSIM («спарсить из статистики»).
  statistics: (limit = 20) =>
    http
      .get<PopularCountriesOut>('/popular-countries/statistics', {
        params: { limit },
      })
      .then((r) => r.data),
  // Весь справочник стран для пикера (+ число активных тарифов).
  catalog: () =>
    http
      .get<PopularCountriesOut>('/popular-countries/catalog')
      .then((r) => r.data),
}

// ---- EXPENSES (справочник расходов: НДС, экваринг, фиксы) ----
export const expensesApi = {
  list: (include_inactive = false) =>
    http
      .get<ExpenseOut[]>('/expenses/', { params: { include_inactive } })
      .then((r) => r.data),
  create: (data: ExpenseCreate) =>
    http.post<ExpenseOut>('/expenses/', data).then((r) => r.data),
  update: (id: number, data: ExpenseUpdate) =>
    http.patch<ExpenseOut>(`/expenses/${id}`, data).then((r) => r.data),
  delete: (id: number) => http.delete(`/expenses/${id}`),
}

// ---- TOPUP MARKUP (Тарифы → Продление) ----------------------------------
//
// Наценка на докупку трафика. Сохраняется не цена, а правило: каталог
// продлений отдаёт агрегатор под конкретный ICCID, поэтому пересчитать
// его заранее, как обычные тарифы, невозможно.
export const topupMarkupApi = {
  // Настройка + справочники для формы (агрегаторы, активные расходы).
  get: () =>
    http.get<TopupMarkupConfigOut>('/topup-markup/').then((r) => r.data),
  // Сохранение целиком: базовая наценка + все правила (replace-all,
  // порядок правил = порядок подбора).
  save: (data: TopupMarkupConfigIn) =>
    http.put<TopupMarkupConfigOut>('/topup-markup/', data).then((r) => r.data),
  // Предпросмотр. `config` считает по несохранённой форме — админ
  // двигает процент и сразу видит будущие цены.
  preview: (data: TopupMarkupPreviewIn) =>
    http
      .post<TopupMarkupPreviewOut>('/topup-markup/preview', data)
      .then((r) => r.data),
}

// ---- SERVICE PRICES (Настройки → Цены за действия в сервисах) -----------
//
// Fallback-цены за одно действие внешнего сервиса (SMS / Telegram Gateway /
// eSIM). Списываются с баланса агрегатора, когда сам агрегатор не прислал
// стоимость в ответе. `amount` — в minor units валюты `currency`.
export const servicePricesApi = {
  list: (include_inactive = true) =>
    http
      .get<ServicePriceOut[]>('/service-prices/', { params: { include_inactive } })
      .then((r) => r.data),
  create: (data: ServicePriceCreate) =>
    http.post<ServicePriceOut>('/service-prices/', data).then((r) => r.data),
  update: (id: number, data: ServicePriceUpdate) =>
    http.patch<ServicePriceOut>(`/service-prices/${id}`, data).then((r) => r.data),
  delete: (id: number) => http.delete(`/service-prices/${id}`),
}

// ---- PLANS: streaming parser --------------------------------------------
//
// NDJSON-стрим от `POST /plans/parse/stream`. axios под XHR в браузере
// не отдаёт тело по чанкам, поэтому используем нативный fetch + ReadableStream.

export interface ParseEventStarted {
  step: 'started'
  account_id: number
  account_label: string
  provider_code: string
  provider_id: number
  create_missing_internal: boolean
  keep_markup_on_cost_change: boolean
  dry_run: boolean
  new_plan_state?: NewPlanState
}
export interface ParseEventDbStatsBefore {
  step: 'db_stats_before'
  plan_rows: number
  provider_plan_rows: number
}
export interface ParseEventDbStatsAfterSession {
  step: 'db_stats_after_session'
  plan_rows: number
  provider_plan_rows: number
}
export interface ParseEventDbStatsAfterCommit {
  step: 'db_stats_after_commit'
  plan_rows: number
  provider_plan_rows: number
}
export interface ParseEventResolveCreds {
  step: 'resolve_credentials'
  ok: boolean
  source: string
  base_url: string
}
export interface ParseEventClientReady {
  step: 'client_ready'
}
export interface ParseEventPlanUpserted {
  step: 'plan_upserted'
  fetched: number
  external_id: string
  name: string
  internal_plan_id: number
  // eSIM Access, Keepgo и eSimerge: записанный тип активации; null — пакет пришёл
  // без activeType, тип в БД не тронут.
  active_type?: number | null
  // Куда ушёл тариф, созданный в этом прогоне (new_plan_state reserve/auto;
  // hidden — в любом режиме, страна убрана из выдачи); null — тариф уже
  // был, его состояние парсер не трогает.
  new_state?: 'on_sale' | 'reserve' | 'hidden' | null
}
export interface ParseEventPlanSkipped {
  step: 'plan_skipped'
  fetched: number
  external_id: string
  name: string
  reason: string
}
// Только Keepgo: бандл не продаём целиком (pSIM, архив, KYC, безлимит) —
// пропущены все его `refills` пакетов.
export interface ParseEventBundleSkipped {
  step: 'bundle_skipped'
  fetched: number
  external_id: string
  name: string
  refills: number
  reason: string
}
// Только Keepgo: страны бандла, которые не перевелись в ISO-2. В
// countries_included они остаются как есть, витрины их не покажут.
export interface ParseEventBundleCountriesUnmapped {
  step: 'bundle_countries_unmapped'
  external_id: string
  name: string
  unmapped: string[]
}
export interface ParseEventPlanFailed {
  step: 'plan_failed'
  fetched: number
  external_id: string | null
  name: string | null
  error: string
}
export interface ParseEventFetchFailed {
  step: 'fetch_failed'
  error: string
  fetched: number
}
// Фаза «перенести изменившуюся закупку в цену»
// (keep_markup_on_cost_change). Все суммы — в минорных единицах валюты
// тарифа (`currency`), закупка уже пересчитана в неё из `cost_currency`.
export interface ParseEventCostShiftApplied {
  step: 'cost_shift_applied'
  plan_id: number
  name: string
  currency: string
  cost_currency: string
  direction: 'drop' | 'rise'
  old_cost: number
  new_cost: number
  old_retail: number
  new_retail: number
  old_markup: number | null
  new_markup: number
  note: string | null
}
export interface ParseEventCostShiftSkipped {
  step: 'cost_shift_skipped'
  plan_id: number
  name: string
  reason: string
}
export interface ParseEventCostShiftDone {
  step: 'cost_shift_done'
  applied: number
  skipped: number
  unchanged: number
  dry_run: boolean
}
export interface ParseEventCostShiftFailed {
  step: 'cost_shift_failed'
  error: string
  watched: number
}
export interface ParseEventDryRunRolledBack {
  step: 'dry_run_rolled_back'
}
export interface ParseEventDone {
  step: 'done'
  fetched: number
  updated: number
  skipped: number
  errors: number
  cost_shift_applied: number
  cost_shift_skipped: number
  dry_run: boolean
  new_plan_state?: NewPlanState
  // Новые тарифы прогона по состояниям; считаются при reserve/auto.
  created_on_sale?: number
  created_reserve?: number
  // Новые тарифы стран, убранных из выдачи: скрыты в любом режиме.
  created_hidden?: number
}
export interface ParseEventCommitFailed {
  step: 'commit_failed'
  error: string
  fetched: number
  updated: number
  skipped: number
  errors: number
}
export type ParseEvent =
  | ParseEventStarted
  | ParseEventDbStatsBefore
  | ParseEventResolveCreds
  | ParseEventClientReady
  | ParseEventPlanUpserted
  | ParseEventPlanSkipped
  | ParseEventBundleSkipped
  | ParseEventBundleCountriesUnmapped
  | ParseEventPlanFailed
  | ParseEventFetchFailed
  | ParseEventCostShiftApplied
  | ParseEventCostShiftSkipped
  | ParseEventCostShiftDone
  | ParseEventCostShiftFailed
  | ParseEventDbStatsAfterSession
  | ParseEventDbStatsAfterCommit
  | ParseEventDryRunRolledBack
  | ParseEventDone
  | ParseEventCommitFailed

export async function streamParsePlans(
  provider_account_id: number,
  opts: {
    create_missing_internal?: boolean
    keep_markup_on_cost_change?: boolean
    dry_run?: boolean
    new_plan_state?: NewPlanState
    token: string | null
    onEvent: (e: ParseEvent) => void
    signal?: AbortSignal
  },
): Promise<void> {
  const url = `${baseURL}/plans/parse/stream`
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/x-ndjson',
  }
  if (opts.token) headers.Authorization = `Bearer ${opts.token}`

  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      provider_account_id,
      create_missing_internal: opts.create_missing_internal ?? true,
      keep_markup_on_cost_change: opts.keep_markup_on_cost_change ?? false,
      dry_run: opts.dry_run ?? false,
      new_plan_state: opts.new_plan_state ?? 'on_sale',
    }),
    signal: opts.signal,
  })
  if (!res.ok || !res.body) {
    let detail = res.statusText
    try {
      const data: any = await res.json()
      if (typeof data?.detail === 'string') detail = data.detail
      else if (Array.isArray(data?.detail))
        detail = data.detail
          .map((d: any) => `${(d.loc ?? []).slice(1).join('.')}: ${d.msg}`)
          .join('\n')
    } catch {
      /* ignore */
    }
    throw new Error(`${res.status} ${detail}`)
  }

  const reader = res.body.getReader()
  const decoder = new TextDecoder('utf-8')
  let buffer = ''
  for (;;) {
    const { done, value } = await reader.read()
    if (done) break
    buffer += decoder.decode(value, { stream: true })
    let nl: number
    while ((nl = buffer.indexOf('\n')) >= 0) {
      const line = buffer.slice(0, nl).trim()
      buffer = buffer.slice(nl + 1)
      if (!line) continue
      try {
        opts.onEvent(JSON.parse(line) as ParseEvent)
      } catch (e) {
        console.warn('parse-stream: bad NDJSON line', line, e)
      }
    }
  }
  const tail = buffer.trim()
  if (tail) {
    try {
      opts.onEvent(JSON.parse(tail) as ParseEvent)
    } catch {
      /* ignore */
    }
  }
}

// ---- PLANS: скрипт «Тип активации eSIM» ----------------------------------
//
// NDJSON-стрим от `POST /plans/active-type/sync/stream`: проставляет
// provider_plan.active_type пакетам eSIM Access по их каталогу. Правила —
// api/admin/services/esimaccess_active_type.py.

interface ActiveTypePlanRef {
  provider_plan_id: number
  plan_id: number
  external_id: string
  name: string | null
}

export interface ActiveTypeEventStarted {
  step: 'started'
  account_id: number
  account_label: string
  provider_code: string
  provider_id: number
  dry_run: boolean
}
export interface ActiveTypeEventResolveCreds {
  step: 'resolve_credentials'
  ok: boolean
  source: string
  base_url: string
}
export interface ActiveTypeEventClientReady {
  step: 'client_ready'
}
// by_type: { "<active_type>": число пакетов }; ключи — строки (JSON).
export interface ActiveTypeEventCatalogLoaded {
  step: 'catalog_loaded'
  packages: number
  by_type: Record<string, number>
}
export interface ActiveTypeEventDbLoaded {
  step: 'db_loaded'
  provider_plans: number
}
export interface ActiveTypeEventPlanChanged extends ActiveTypePlanRef {
  step: 'plan_changed'
  old: number
  new: number
}
// Пакета нет в каталоге (снят с продажи) — тип не тронут.
export interface ActiveTypeEventPlanMissing extends ActiveTypePlanRef {
  step: 'plan_missing'
  active_type: number
}
// Пакет есть, но пришёл без activeType — тип не тронут.
export interface ActiveTypeEventPlanNoType extends ActiveTypePlanRef {
  step: 'plan_no_type'
  active_type: number
}
export interface ActiveTypeEventFetchFailed {
  step: 'fetch_failed'
  error: string
}
export interface ActiveTypeEventCommitFailed {
  step: 'commit_failed'
  error: string
}
export interface ActiveTypeEventDone {
  step: 'done'
  catalog_packages: number
  provider_plans: number
  changed: number
  unchanged: number
  missing: number
  no_type: number
  // Числа из каталога, которых нет в ESimActivationType: записаны как 0,
  // enum нужно дописать.
  unknown_values: number[]
  // Распределение наших пакетов по типам после записи.
  by_type: Record<string, number>
  dry_run: boolean
}
export type ActiveTypeEvent =
  | ActiveTypeEventStarted
  | ActiveTypeEventResolveCreds
  | ActiveTypeEventClientReady
  | ActiveTypeEventCatalogLoaded
  | ActiveTypeEventDbLoaded
  | ActiveTypeEventPlanChanged
  | ActiveTypeEventPlanMissing
  | ActiveTypeEventPlanNoType
  | ActiveTypeEventFetchFailed
  | ActiveTypeEventCommitFailed
  | ActiveTypeEventDone

export async function streamSyncActiveTypes(
  provider_account_id: number,
  opts: {
    token: string | null
    dryRun: boolean
    onEvent: (e: ActiveTypeEvent) => void
    signal?: AbortSignal
  },
): Promise<void> {
  const url = `${baseURL}/plans/active-type/sync/stream`
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/x-ndjson',
  }
  if (opts.token) headers.Authorization = `Bearer ${opts.token}`

  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({ provider_account_id, dry_run: opts.dryRun }),
    signal: opts.signal,
  })
  if (!res.ok || !res.body) {
    let detail = res.statusText
    try {
      const data: any = await res.json()
      if (typeof data?.detail === 'string') detail = data.detail
      else if (Array.isArray(data?.detail))
        detail = data.detail
          .map((d: any) => `${(d.loc ?? []).slice(1).join('.')}: ${d.msg}`)
          .join('\n')
    } catch {
      /* ignore */
    }
    throw new Error(`${res.status} ${detail}`)
  }

  const reader = res.body.getReader()
  const decoder = new TextDecoder('utf-8')
  let buffer = ''
  for (;;) {
    const { done, value } = await reader.read()
    if (done) break
    buffer += decoder.decode(value, { stream: true })
    let nl: number
    while ((nl = buffer.indexOf('\n')) >= 0) {
      const line = buffer.slice(0, nl).trim()
      buffer = buffer.slice(nl + 1)
      if (!line) continue
      try {
        opts.onEvent(JSON.parse(line) as ActiveTypeEvent)
      } catch (e) {
        console.warn('active-type-stream: bad NDJSON line', line, e)
      }
    }
  }
  const tail = buffer.trim()
  if (tail) {
    try {
      opts.onEvent(JSON.parse(tail) as ActiveTypeEvent)
    } catch {
      /* ignore */
    }
  }
}

// ---- ESIMS: streaming «lost / orphan» scanner ----------------------------
//
// NDJSON-стрим от `POST /esims/scripts/lost/scan/stream`. По смыслу — то же,
// что и `/plans/parse/stream`: ходим в API провайдера и отдаём событие на
// каждую найденную карточку, чтобы UI рисовал «консоль» в реальном времени.
// Реализация копирует формат plans-parse-стрима сознательно: одна и та же
// «лента событий» удобна и админу (понятная картинка), и разработчику
// (общий код парсинга).

export interface LostScanEventStarted {
  step: 'started'
  account_id: number
  account_label: string
  provider_code: string
  provider_id: number
}
export interface LostScanEventDbIndexBuilt {
  step: 'db_index_built'
  known_iccids: number
  known_external_refs: number
}
export interface LostScanEventResolveCreds {
  step: 'resolve_credentials'
  ok: boolean
  source: string
  base_url: string
}
export interface LostScanEventClientReady {
  step: 'client_ready'
}
export interface LostScanEventESimKnown {
  step: 'esim_known'
  fetched: number
  iccid: string
  external_reference: string | null
}
export interface LostScanEventESimLost {
  step: 'esim_lost'
  fetched: number
  item: LostESimItem
}
export interface LostScanEventESimFailed {
  step: 'esim_failed'
  fetched: number
  iccid: string
  error: string
}
export interface LostScanEventFetchFailed {
  step: 'fetch_failed'
  fetched: number
  error: string
}
export interface LostScanEventCommitFailed {
  step: 'commit_failed'
  error: string
  fetched?: number
  lost?: number
  known?: number
  errors?: number
}
export interface LostScanEventDone {
  step: 'done'
  fetched: number
  lost: number
  known: number
  errors: number
}
export type LostScanEvent =
  | LostScanEventStarted
  | LostScanEventDbIndexBuilt
  | LostScanEventResolveCreds
  | LostScanEventClientReady
  | LostScanEventESimKnown
  | LostScanEventESimLost
  | LostScanEventESimFailed
  | LostScanEventFetchFailed
  | LostScanEventCommitFailed
  | LostScanEventDone

export async function streamScanLostESims(
  provider_account_id: number,
  opts: {
    token: string | null
    onEvent: (e: LostScanEvent) => void
    signal?: AbortSignal
  },
): Promise<void> {
  const url = `${baseURL}/esims/scripts/lost/scan/stream?provider_account_id=${provider_account_id}`
  const headers: Record<string, string> = {
    Accept: 'application/x-ndjson',
  }
  if (opts.token) headers.Authorization = `Bearer ${opts.token}`

  const res = await fetch(url, {
    method: 'POST',
    headers,
    signal: opts.signal,
  })
  if (!res.ok || !res.body) {
    let detail = res.statusText
    try {
      const data: any = await res.json()
      if (typeof data?.detail === 'string') detail = data.detail
      else if (Array.isArray(data?.detail))
        detail = data.detail
          .map((d: any) => `${(d.loc ?? []).slice(1).join('.')}: ${d.msg}`)
          .join('\n')
    } catch {
      /* ignore */
    }
    throw new Error(`${res.status} ${detail}`)
  }

  const reader = res.body.getReader()
  const decoder = new TextDecoder('utf-8')
  let buffer = ''
  for (;;) {
    const { done, value } = await reader.read()
    if (done) break
    buffer += decoder.decode(value, { stream: true })
    let nl: number
    while ((nl = buffer.indexOf('\n')) >= 0) {
      const line = buffer.slice(0, nl).trim()
      buffer = buffer.slice(nl + 1)
      if (!line) continue
      try {
        opts.onEvent(JSON.parse(line) as LostScanEvent)
      } catch (e) {
        console.warn('lost-scan-stream: bad NDJSON line', line, e)
      }
    }
  }
  const tail = buffer.trim()
  if (tail) {
    try {
      opts.onEvent(JSON.parse(tail) as LostScanEvent)
    } catch {
      /* ignore */
    }
  }
}

// ---- ESIMS: streaming bulk sync (refresh ALL eSIM for an account) -------
//
// NDJSON-стрим от `POST /esims/scripts/sync-all/stream`. По смыслу:
// «прогнать в API провайдера ВСЕ наши eSIM этого аккаунта и обновить
// у каждой свежие status / data_used / plan_expired_at». Полезно, если
// у провайдера упали вебхуки (eSIM Access) или их вообще нет (SmartCard).
//
// Семантика событий описана в backend-комментарии у `sync_all_esims_stream`.
// Формат событий унифицирован с lost-scan-стримом (тот же UI-шаблон
// NDJSON-консоли + сводка).

export type BulkSyncStatusChange = { old: string; new: string }
export type BulkSyncNumChange = { old: number | null; new: number }
export type BulkSyncDateChange = { old: string | null; new: string }
export interface BulkSyncDiff {
  status?: BulkSyncStatusChange
  data_total_mb?: BulkSyncNumChange
  data_used_mb?: BulkSyncNumChange
  plan_activated_at?: BulkSyncDateChange
  plan_expired_at?: BulkSyncDateChange
}

export interface BulkSyncEventStarted {
  step: 'started'
  account_id: number
  account_label: string
  provider_code: string
  provider_id: number
}
export interface BulkSyncEventDbIndexBuilt {
  step: 'db_index_built'
  to_sync: number
}
export interface BulkSyncEventResolveCreds {
  step: 'resolve_credentials'
  ok: boolean
  source: string
  base_url: string
}
export interface BulkSyncEventClientReady {
  step: 'client_ready'
}
export interface BulkSyncEventESimSynced {
  step: 'esim_synced'
  fetched: number
  iccid: string | null
  esim_id: number
  user_id: number
  diff: BulkSyncDiff
}
export interface BulkSyncEventESimSkipped {
  step: 'esim_skipped'
  fetched: number
  iccid: string | null
  esim_id?: number
  reason: string
}
export interface BulkSyncEventESimFailed {
  step: 'esim_failed'
  fetched: number
  iccid: string | null
  esim_id?: number
  error: string
}
export interface BulkSyncEventFetchFailed {
  step: 'fetch_failed'
  fetched: number
  error: string
}
export interface BulkSyncEventCommitFailed {
  step: 'commit_failed'
  error: string
  fetched?: number
  synced?: number
  orphan?: number
  errors?: number
}
export interface BulkSyncEventDone {
  step: 'done'
  fetched: number
  synced: number
  orphan: number
  errors: number
}
export type BulkSyncEvent =
  | BulkSyncEventStarted
  | BulkSyncEventDbIndexBuilt
  | BulkSyncEventResolveCreds
  | BulkSyncEventClientReady
  | BulkSyncEventESimSynced
  | BulkSyncEventESimSkipped
  | BulkSyncEventESimFailed
  | BulkSyncEventFetchFailed
  | BulkSyncEventCommitFailed
  | BulkSyncEventDone

export async function streamBulkSyncESims(
  provider_account_id: number,
  opts: {
    token: string | null
    onEvent: (e: BulkSyncEvent) => void
    signal?: AbortSignal
  },
): Promise<void> {
  const url = `${baseURL}/esims/scripts/sync-all/stream?provider_account_id=${provider_account_id}`
  const headers: Record<string, string> = {
    Accept: 'application/x-ndjson',
  }
  if (opts.token) headers.Authorization = `Bearer ${opts.token}`

  const res = await fetch(url, {
    method: 'POST',
    headers,
    signal: opts.signal,
  })
  if (!res.ok || !res.body) {
    let detail = res.statusText
    try {
      const data: any = await res.json()
      if (typeof data?.detail === 'string') detail = data.detail
      else if (Array.isArray(data?.detail))
        detail = data.detail
          .map((d: any) => `${(d.loc ?? []).slice(1).join('.')}: ${d.msg}`)
          .join('\n')
    } catch {
      /* ignore */
    }
    throw new Error(`${res.status} ${detail}`)
  }

  const reader = res.body.getReader()
  const decoder = new TextDecoder('utf-8')
  let buffer = ''
  for (;;) {
    const { done, value } = await reader.read()
    if (done) break
    buffer += decoder.decode(value, { stream: true })
    let nl: number
    while ((nl = buffer.indexOf('\n')) >= 0) {
      const line = buffer.slice(0, nl).trim()
      buffer = buffer.slice(nl + 1)
      if (!line) continue
      try {
        opts.onEvent(JSON.parse(line) as BulkSyncEvent)
      } catch (e) {
        console.warn('bulk-sync-stream: bad NDJSON line', line, e)
      }
    }
  }
  const tail = buffer.trim()
  if (tail) {
    try {
      opts.onEvent(JSON.parse(tail) as BulkSyncEvent)
    } catch {
      /* ignore */
    }
  }
}

// ---- ESIMS: «Заполнить даты активации и окончания» (только eSIM Access) --
//
// NDJSON-стрим от `POST /esims/scripts/fill-dates/stream`. Для карт без
// `plan_activated_at` / `plan_expired_at` берёт даты из профиля
// провайдера и заполняет только пустые поля; статус не трогает.
// Шаги и правила — api/admin/services/esimaccess_fill_dates.py.

export type FillDatesField = 'plan_activated_at' | 'plan_expired_at'

interface FillDatesEsimRef {
  fetched: number
  esim_id: number
  user_id: number
  iccid: string
}

export interface FillDatesEventStarted {
  step: 'started'
  account_id: number
  account_label: string
  provider_code: string
  provider_id: number
  dry_run: boolean
}
export interface FillDatesEventDbIndexBuilt {
  step: 'db_index_built'
  to_check: number
}
export interface FillDatesEventResolveCreds {
  step: 'resolve_credentials'
  ok: boolean
  source: string
  base_url: string
}
export interface FillDatesEventClientReady {
  step: 'client_ready'
}
export interface FillDatesEventESimFilled extends FillDatesEsimRef {
  step: 'esim_filled'
  dates: Partial<Record<FillDatesField, string>>
  dry_run: boolean
}
export interface FillDatesEventESimNotActivated extends FillDatesEsimRef {
  step: 'esim_not_activated'
  provider_status: string | null
  // Крайний срок активации от провайдера (их expiredTime до активации).
  activation_deadline: string | null
}
export interface FillDatesEventESimSkipped extends FillDatesEsimRef {
  step: 'esim_skipped'
  reason: string
}
export interface FillDatesEventESimFailed extends FillDatesEsimRef {
  step: 'esim_failed'
  error: string
}
export interface FillDatesEventFetchFailed {
  step: 'fetch_failed'
  error: string
}
export interface FillDatesEventCommitFailed {
  step: 'commit_failed'
  error: string
}
export interface FillDatesEventDone {
  step: 'done'
  checked: number
  filled: number
  not_activated: number
  skipped: number
  errors: number
  dry_run: boolean
}
export type FillDatesEvent =
  | FillDatesEventStarted
  | FillDatesEventDbIndexBuilt
  | FillDatesEventResolveCreds
  | FillDatesEventClientReady
  | FillDatesEventESimFilled
  | FillDatesEventESimNotActivated
  | FillDatesEventESimSkipped
  | FillDatesEventESimFailed
  | FillDatesEventFetchFailed
  | FillDatesEventCommitFailed
  | FillDatesEventDone

export async function streamFillESimDates(
  provider_account_id: number,
  opts: {
    token: string | null
    dryRun: boolean
    onEvent: (e: FillDatesEvent) => void
    signal?: AbortSignal
  },
): Promise<void> {
  const params = new URLSearchParams({
    provider_account_id: String(provider_account_id),
    dry_run: String(opts.dryRun),
  })
  const url = `${baseURL}/esims/scripts/fill-dates/stream?${params}`
  const headers: Record<string, string> = {
    Accept: 'application/x-ndjson',
  }
  if (opts.token) headers.Authorization = `Bearer ${opts.token}`

  const res = await fetch(url, {
    method: 'POST',
    headers,
    signal: opts.signal,
  })
  if (!res.ok || !res.body) {
    let detail = res.statusText
    try {
      const data: any = await res.json()
      if (typeof data?.detail === 'string') detail = data.detail
      else if (Array.isArray(data?.detail))
        detail = data.detail
          .map((d: any) => `${(d.loc ?? []).slice(1).join('.')}: ${d.msg}`)
          .join('\n')
    } catch {
      /* ignore */
    }
    throw new Error(`${res.status} ${detail}`)
  }

  const reader = res.body.getReader()
  const decoder = new TextDecoder('utf-8')
  let buffer = ''
  for (;;) {
    const { done, value } = await reader.read()
    if (done) break
    buffer += decoder.decode(value, { stream: true })
    let nl: number
    while ((nl = buffer.indexOf('\n')) >= 0) {
      const line = buffer.slice(0, nl).trim()
      buffer = buffer.slice(nl + 1)
      if (!line) continue
      try {
        opts.onEvent(JSON.parse(line) as FillDatesEvent)
      } catch (e) {
        console.warn('fill-dates-stream: bad NDJSON line', line, e)
      }
    }
  }
  const tail = buffer.trim()
  if (tail) {
    try {
      opts.onEvent(JSON.parse(tail) as FillDatesEvent)
    } catch {
      /* ignore */
    }
  }
}

// Массовая аварийная замена eSIM (скрипт «Возврат при аварии») теперь
// идёт ФОНОВЫМ прогоном в процессе admin-API: POST .../replace/jobs
// мгновенно отвечает строкой прогона (job_id), дальше UI поллит
// GET .../jobs/{id}?after=<cursor> и дочитывает журнал порциями.
// Обрыв соединения / закрытая вкладка / «Load failed» на замену НЕ
// влияют — после перезагрузки страницы карточка прицепляется к
// идущему прогону заново (см. методы emergencyJob* в esimsApi ниже).

// ---- DISCOUNTS ----
export const discountsApi = {
  list: (params: { user_id?: number; status?: string } = {}) =>
    http.get<DiscountOut[]>('/discounts/', { params }).then((r) => r.data),
  create: (data: any) => http.post<DiscountOut>('/discounts/', data).then((r) => r.data),
  update: (id: number, data: any) =>
    http.patch<DiscountOut>(`/discounts/${id}`, data).then((r) => r.data),
  // Без hard — мягкая «пауза» (status='paused'), исторически так
  // работала кнопка «Пауза». hard=true — физическое удаление; если по
  // промокоду уже были применения, backend вернёт 409 — тогда нужен
  // force=true (история применений будет удалена тоже).
  delete: (id: number, hard = false, force = false) =>
    http.delete(`/discounts/${id}`, {
      params: { hard, force },
      // 409 = «по промокоду уже были применения» — DiscountsView сам
      // покажет confirm «удалить вместе с историей?», глобальный тост
      // не нужен.
      skipErrorToast: (status: number) => status === 409,
    }),
  issuePersonal: (user_id: number, data: any) =>
    http
      .post<DiscountOut>(`/discounts/users/${user_id}/promocode`, data)
      .then((r) => r.data),
}

// ---- PAYMENTS / ESIMS / AUDIT ----
//
// Удаление платежей доступно админу для разгребания «зависших»
// тестовых записей. Бэкенд защищает по правилам:
//   * без force — только платежи в терминальных статусах
//     (CONFIRMED/REJECTED/CANCELED/REFUNDED/…). Активные — 422.
//   * force=true — снять защиту (после явного подтверждения в UI).
// Опционально cancel_in_acquirer=true просит backend вызвать
// /v2/Cancel в T-Bank перед удалением — ошибки cancel не блокируют
// delete, но попадают в результат и в audit-log.

export interface DeletePaymentResult {
  payment_id: number
  deleted: boolean
  pre_status: string
  cancel_in_acquirer: boolean
  cancel_result: {
    called: boolean
    reason?: string
    ok?: boolean
    status?: string | null
    error?: string
    error_code?: string | null
    error_type?: string
    order_id?: string
  } | null
}

export interface PaymentsListParams {
  user_id?: number
  status?: string
  since?: string
  until?: string
  // Идентификатор рекламного клика ('gclid', 'yclid', …) — точное
  // совпадение. Отбирает заказы, пришедшие с визита с этой меткой.
  click_id?: string
  // Из какого клиента пришла оплата: 'app' | 'site' | 'tg' либо 'none'
  // — «источник не прислали». Отдельное слово, а не пустая строка:
  // пустая означает «не фильтровать», и выбрать платежи без источника
  // ею было бы нечем.
  source?: string
  // «Умный» поиск одной строкой: №, order_id, PaymentId, e-mail, сумма,
  // маска карты (см. api/admin/services/payment_search.py).
  search?: string
  limit?: number
  offset?: number
}

// Результат возврата платежа по чеку (POST /payments/{id}/refund).
// Доступно только superadmin (см. require_superadmin на бэкенде).
export interface RefundPaymentResult {
  payment_id: number
  refunded: boolean
  pre_status: string
  status: string
  requested_amount: number
  refunded_amount: number
  acquirer_status: string | null
}

// Результат ручной сверки статуса платежа с эквайрингом
// (POST /payments/{id}/sync-status). Backend дёргает T-Bank GetState и
// при «свежем» статусе обновляет payment.status; если итог CONFIRMED и
// issue_esims=true — ставит выпуск eSIM в очередь (как вебхук).
export interface PaymentSyncStatusResult {
  payment_id: number
  synced: boolean
  pre_status: string
  status: string
  acquirer_status: string | null
  changed: boolean
  paid_at: string | null
  fulfillment_enqueued: boolean
  note: string | null
}

export const paymentsApi = {
  list: (params: PaymentsListParams = {}) =>
    http
      .get<PaymentOut[]>('/payments/', {
        params: cleanParams(params as Record<string, unknown>),
      })
      .then((r) => r.data),
  // Сколько платежей подходит под те же фильтры (для пагинации).
  // Backend отдаёт { total }. Фильтры передаём те же, что и в list
  // (без limit/offset).
  count: (params: Omit<PaymentsListParams, 'limit' | 'offset'> = {}) =>
    http
      .get<{ total: number }>('/payments/count', {
        params: cleanParams(params as Record<string, unknown>),
      })
      .then((r) => r.data.total),
  get: (id: number) => http.get<PaymentOut>(`/payments/${id}`).then((r) => r.data),
  // Разбивка оплат по каналам за период: сколько и на сколько заплатили
  // из приложения, с сайта и из Telegram. Только оплаченные платежи;
  // строка с source=null — те, кто источник ещё не присылает.
  sources: (params: { since?: string; until?: string } = {}) =>
    http
      .get<PaymentSourceStat[]>('/payments/sources', {
        params: cleanParams(params as Record<string, unknown>),
      })
      .then((r) => r.data),
  delete: (
    id: number,
    opts: { force?: boolean; cancel_in_acquirer?: boolean } = {},
  ) =>
    http
      .delete<DeletePaymentResult>(`/payments/${id}`, {
        params: {
          force: opts.force ?? false,
          cancel_in_acquirer: opts.cancel_in_acquirer ?? false,
        },
      })
      .then((r) => r.data),
  // Вернуть платёж по чеку через эквайринг (T-Bank /v2/Cancel). Только
  // superadmin. amount (минорные единицы) — частичный возврат; не передан
  // = весь остаток (total_amount - refunded_amount).
  refund: (id: number, opts: { amount?: number } = {}) =>
    http
      .post<RefundPaymentResult>(`/payments/${id}/refund`, {
        amount: opts.amount ?? null,
      })
      .then((r) => r.data),
  // Сверить статус платежа с эквайрингом (T-Bank GetState) и обновить
  // его вручную. Нужно, когда вебхук не дошёл и платёж завис в NEW.
  // issue_esims (по умолчанию true) — поставить выпуск eSIM в очередь,
  // если по итогу платёж confirmed (как сделал бы вебхук).
  syncStatus: (id: number, opts: { issue_esims?: boolean } = {}) =>
    http
      .post<PaymentSyncStatusResult>(`/payments/${id}/sync-status`, {
        issue_esims: opts.issue_esims ?? true,
      })
      .then((r) => r.data),
}

// Универсальный поиск в шапке (GET /search): клиенты, eSIM и чеки одной
// строкой. `signal` — чтобы отменить устаревший запрос, пока админ печатает.
// Без тоста: запрос уходит на каждую паузу в наборе, и ошибка показывается
// прямо в выпадающем списке, а не стопкой тостов.
export const searchApi = {
  global: (q: string, opts: { limit?: number; signal?: AbortSignal } = {}) =>
    http
      .get<GlobalSearchOut>('/search', {
        params: { q, limit: opts.limit },
        signal: opts.signal,
        skipErrorToast: true,
      })
      .then((r) => r.data),
}

export const esimsApi = {
  // Страница списка eSIM. Фильтры — query-параметрами (те же имена, что
  // у фильтров конструктора отчётов: найденную выборку можно выгрузить
  // в файл без переделки). Массивы уходят повтором имени параметра, см.
  // paramsSerializer в client.ts.
  list: (params: any = {}) => http.get<ESimOut[]>('/esims/', { params }).then((r) => r.data),
  // Сколько eSIM подходит под те же фильтры (для пагинации). Backend
  // отдаёт { total }. Фильтры — те же, что в list (без limit/offset).
  count: (params: any = {}) =>
    http
      .get<{ total: number }>('/esims/count', { params })
      .then((r) => r.data.total),
  // Справочники для панели фильтров: статусы и состояния с русскими
  // подписями, провайдеры с аккаунтами, тарифы, страны, быстрые
  // фильтры. Собраны по фактически выпущенным картам, с количеством у
  // каждого пункта. Тянется один раз при открытии раздела. Как и facets,
  // «мягкая»: без справочников панель теряет только выпадающие списки,
  // поэтому красный тост поверх работающего списка тут лишний.
  filtersMeta: () =>
    http
      .get<ESimFiltersMeta>('/esims/filters/meta', { skipErrorToast: true })
      .then((r) => r.data),
  // Счётчики «сколько найдётся, если выбрать этот пункт» при ТЕКУЩИХ
  // фильтрах — числа в выпадающих списках. Параметры те же, что у list.
  // Ручка «мягкая»: не доехала (старый admin-API) — панель просто
  // покажет статические count вместо динамических, без красного тоста.
  facets: (params: any = {}) =>
    http
      .get<ESimSearchFacets>('/esims/facets', { params, skipErrorToast: true })
      .then((r) => r.data),
  get: (id: number) => http.get<ESimOut>(`/esims/${id}`).then((r) => r.data),
  // Журнал esim_event конкретной eSIM (сначала новые). Для FAILED-карт в
  // payload — причина провала выпуска (показываем в модалке «Журнал»).
  events: (id: number) =>
    http.get<ESimEventOut[]>(`/esims/${id}/events`).then((r) => r.data),
  forceStatus: (id: number, status: string) =>
    http
      .post<ESimOut>(`/esims/${id}/force-status`, null, { params: { new_status: status } })
      .then((r) => r.data),
  // Сходить в API провайдера (SmartCard / eSIM Access / Keepgo / eSimerge) за свежими
  // полями eSIM (status, data_total_mb, plan_expired_at, ...). Идёт
  // через общий ESimProviderAdapter.get_esim_traffic — поэтому работает
  // для всех агрегаторов одинаково. Используется кнопкой
  // «🔄 Обновить из провайдера» в ESimsView.
  //
  // Возвращает не только обновлённую eSIM, но и сырой ответ агрегатора
  // (ESimProviderSyncResult) — иначе расхождение «провайдер говорит
  // activated, у нас terminated» разбирается только по логам сервера.
  // Ошибка агрегатора приезжает как pulled_from_api=false + note (200),
  // так что тостами остаются только 404/409 самой админки.
  syncFromProvider: (id: number) =>
    http
      .post<ESimProviderSyncResult>(`/esims/${id}/sync-from-provider`)
      .then((r) => r.data),
  // «Вернуть» неактивированную eSIM провайдеру (отмена с рефандом на
  // баланс кабинета у агрегатора; у keepgo — заявка, деньги придут после
  // проверки поддержкой). Работает только для esimaccess и keepgo (у
  // eSimerge отмены в API нет) и только для карт в неактивированных статусах (issued / pending с
  // ICCID) — иначе backend отдаёт 409/502. Успех переводит eSIM в
  // статус terminated. Опционально возвращает деньги КЛИЕНТУ
  // (body.client_refund: 'balance' — на внутренний баланс,
  // 'payment_reversal' — отменой операции платежа, только superadmin).
  // Возвращает обновлённую eSIM + итог возврата (ESimReturnResult).
  // Используется кнопкой «Вернуть».
  returnUnused: (id: number, body: ESimReturnRequest = {}) =>
    http
      .post<ESimReturnResult>(`/esims/${id}/return`, body)
      .then((r) => r.data),
  // Убрать мёртвую карту из кабинета клиента за него (то же, что клиентский
  // DELETE /me/esims/{id}). Живую карту бэкенд не скрывает — 409.
  hideFromClient: (id: number) =>
    http.post<ESimOut>(`/esims/${id}/hide-from-client`).then((r) => r.data),
  // Вернуть скрытую карту в кабинет клиента, кто бы её ни скрыл.
  showToClient: (id: number) =>
    http.post<ESimOut>(`/esims/${id}/show-to-client`).then((r) => r.data),
  // Привязать «потерявшуюся» eSIM провайдера к нашему клиенту
  // (SmartCard / Keepgo / eSimerge — создаёт новую строку в esim).
  // Бэкенд:
  //   * перепроверяет факт существования eSIM у провайдера;
  //   * идемпотентно: если ICCID уже привязан — отдаёт ту запись;
  //   * пишет esim_event + admin_audit_log.
  assignLost: (body: LostESimAssignRequest) =>
    http
      .post<ESimOut>('/esims/scripts/lost/assign', body)
      .then((r) => r.data),
  // Восстановить «потерявшуюся» eSIM (eSIM Access / Keepgo / eSimerge —
  // UPDATE существующей записи).
  // Бэкенд:
  //   * перепроверяет факт существования eSIM у провайдера через
  //     query_esim(transactionId=<provider_idempotency_key>), у Keepgo —
  //     линию body.iccid, в notes которой наш номер заказа, у eSimerge —
  //     карту body.provider_esim_id (без него — по id карты и заказа записи
  //     и нашей ссылке в листинге заказов);
  //   * UPDATE-аем status / iccid / lpa_code / data_* / plan_*;
  //   * идемпотентно: если eSIM уже не FAILED и iccid проставлен —
  //     отдаём её as-is;
  //   * пишет esim_event(EXTERNAL_SYNCED) + admin_audit_log.
  reactivateLost: (body: LostESimReactivateRequest) =>
    http
      .post<ESimOut>('/esims/scripts/lost/reactivate', body)
      .then((r) => r.data),
  // Кандидаты на аварийную замену (скрипт «Возврат при аварии»).
  // Все фильтры опциональны; массивы (provider_ids / country_codes /
  // statuses) уходят повтором имени параметра — см. paramsSerializer
  // в client.ts. Ответ: { items, total }.
  emergencyCandidates: (params: EmergencyCandidatesParams = {}) =>
    http
      .get<EmergencyCandidatesResponse>(
        '/esims/scripts/emergency/candidates',
        { params },
      )
      .then((r) => r.data),
  // Запуск фонового прогона замены. 409 = уже идёт другой прогон
  // (параллельные запрещены) — карточка сама прицепится к идущему,
  // глобальный тост не нужен.
  emergencyJobStart: (body: EmergencyReplaceRequest) =>
    http
      .post<EmergencyJob>('/esims/scripts/emergency/replace/jobs', body, {
        skipErrorToast: (status: number) => status === 409,
      })
      .then((r) => r.data),
  // Последние прогоны (новые сверху), без журналов — история + поиск
  // идущего прогона при открытии карточки.
  emergencyJobs: (limit = 10) =>
    http
      .get<EmergencyJob[]>('/esims/scripts/emergency/replace/jobs', {
        params: { limit },
      })
      .then((r) => r.data),
  // Строка прогона + события журнала с курсора after (0 = весь журнал).
  // Поллится раз в ~2с, пока job.status === 'running'; ошибки сети
  // глушим локально в карточке (прогон на сервере от них не страдает).
  emergencyJob: (jobId: number, after = 0) =>
    http
      .get<EmergencyJobDetail>(
        `/esims/scripts/emergency/replace/jobs/${jobId}`,
        { params: { after }, skipErrorToast: true },
      )
      .then((r) => r.data),
  // Кооперативная остановка: раннер прервётся между картами, уже
  // сделанные замены сохранены.
  emergencyJobStop: (jobId: number) =>
    http
      .post<EmergencyJob>(
        `/esims/scripts/emergency/replace/jobs/${jobId}/stop`,
      )
      .then((r) => r.data),

  // ---- Скрипт «Сформировать отчёт» --------------------------------------
  //
  // Справочники для конструктора: колонки с группами и подписями,
  // пресеты наборов колонок, форматы файлов, значения перечислений и
  // лимиты. Тянется один раз при открытии карточки.
  reportMeta: () =>
    http
      .get<ESimReportMetaOut>('/esims/scripts/report/meta')
      .then((r) => r.data),
  // Предпросмотр: страница строк + итоги + расшифровка фильтров, БЕЗ
  // формирования файла. Оператор сначала смотрит выборку, потом качает.
  reportPreview: (body: ESimReportPreviewRequest) =>
    http
      .post<ESimReportPreviewOut>('/esims/scripts/report/preview', body)
      .then((r) => r.data),
  // Сам файл. Ответ бинарный (XLSX/PDF), поэтому responseType=blob;
  // имя файла бэкенд отдаёт в Content-Disposition (заголовок открыт для
  // JS через CORS expose_headers, см. api/admin/main.py).
  reportExport: (body: ESimReportExportRequest) =>
    http
      .post<Blob>('/esims/scripts/report/export', body, {
        responseType: 'blob',
        // Отчёт на десятки тысяч строк рендерится синхронно в запросе —
        // дефолтных 30 секунд на XLSX/PDF такого размера не хватает.
        timeout: 300_000,
      })
      .then((r) => ({
        blob: r.data,
        // Фолбэк с расширением — на случай, если заголовок до JS не
        // доехал (прокси его срезал, старый admin-API без
        // expose_headers): файл без расширения система не откроет.
        filename: filenameFromDisposition(
          r.headers['content-disposition'] as string | undefined,
          `esim_report.${body.format}`,
        ),
      })),
}

/**
 * Достать имя файла из заголовка `Content-Disposition`.
 *
 * Бэкенд отдаёт оба варианта по RFC 6266: ASCII-огрызок в `filename=`
 * и полное UTF-8-имя в `filename*=UTF-8''…` (в отчётах имя может быть
 * с кириллицей). Предпочитаем `filename*`.
 */
export function filenameFromDisposition(
  disposition: string | undefined,
  fallback = 'report',
): string {
  if (!disposition) return fallback
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition)
  if (utf8?.[1]) {
    try {
      return decodeURIComponent(utf8[1].trim())
    } catch {
      /* битый percent-encoding — падаём на ASCII-вариант ниже */
    }
  }
  const ascii = /filename="?([^";]+)"?/i.exec(disposition)
  return ascii?.[1]?.trim() || fallback
}

/**
 * Отдать blob браузеру как скачиваемый файл.
 *
 * Единственный способ инициировать загрузку из XHR-ответа: временный
 * object URL + клик по невидимой ссылке. URL обязательно освобождаем,
 * иначе blob висит в памяти вкладки до её закрытия.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  try {
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    link.remove()
  } finally {
    // Safari не успевает начать загрузку, если revoke сделать синхронно.
    window.setTimeout(() => URL.revokeObjectURL(url), 10_000)
  }
}

// ---- eSIM SYNC SCHEDULERS (раздел «eSIM → Шедулеры») ----
//
// Периодические задания на фоновое обновление данных о клиентских eSIM.
// Сам прогон делает фоновый раннер внутри admin-API
// (api/admin/services/esim_sync_runner.py); этот API — управление
// таблицей esim_sync_scheduler (CRUD + enable/disable + run-now).
export const esimSchedulersApi = {
  list: () =>
    http
      .get<ESimSyncSchedulerOut[]>('/esim-schedulers/')
      .then((r) => r.data),
  get: (id: number) =>
    http
      .get<ESimSyncSchedulerOut>(`/esim-schedulers/${id}`)
      .then((r) => r.data),
  create: (body: ESimSyncSchedulerCreate) =>
    http
      .post<ESimSyncSchedulerOut>('/esim-schedulers/', body)
      .then((r) => r.data),
  update: (id: number, body: ESimSyncSchedulerUpdate) =>
    http
      .patch<ESimSyncSchedulerOut>(`/esim-schedulers/${id}`, body)
      .then((r) => r.data),
  delete: (id: number) => http.delete(`/esim-schedulers/${id}`),
  enable: (id: number) =>
    http
      .post<ESimSyncSchedulerOut>(`/esim-schedulers/${id}/enable`)
      .then((r) => r.data),
  disable: (id: number) =>
    http
      .post<ESimSyncSchedulerOut>(`/esim-schedulers/${id}/disable`)
      .then((r) => r.data),
  runNow: (id: number) =>
    http
      .post<ESimSyncSchedulerOut>(`/esim-schedulers/${id}/run-now`)
      .then((r) => r.data),
  runnerStatus: () =>
    http
      .get<ESimSyncSchedulerRunnerStatus>('/esim-schedulers/runner/status')
      .then((r) => r.data),
}

// ---- PROVIDER BALANCE SCHEDULERS (раздел «eSIM Провайдеры → Шедулеры») ----
//
// Периодическая проверка баланса кабинетов у агрегаторов: хватает ли
// денег на самую дорогую eSIM в клиентской выдаче. Не хватает — алёрт в
// Telegram, ноль — авто-скрытие провайдера из выдачи. Прогон делает
// раннер api/admin/services/provider_balance_runner.py; этот API —
// управление таблицей provider_balance_scheduler.
export const providerBalanceSchedulersApi = {
  list: () =>
    http
      .get<ProviderBalanceSchedulerOut[]>('/provider-balance-schedulers/')
      .then((r) => r.data),
  get: (id: number) =>
    http
      .get<ProviderBalanceSchedulerOut>(`/provider-balance-schedulers/${id}`)
      .then((r) => r.data),
  create: (body: ProviderBalanceSchedulerCreate) =>
    http
      .post<ProviderBalanceSchedulerOut>('/provider-balance-schedulers/', body)
      .then((r) => r.data),
  update: (id: number, body: ProviderBalanceSchedulerUpdate) =>
    http
      .patch<ProviderBalanceSchedulerOut>(
        `/provider-balance-schedulers/${id}`,
        body,
      )
      .then((r) => r.data),
  delete: (id: number) => http.delete(`/provider-balance-schedulers/${id}`),
  enable: (id: number) =>
    http
      .post<ProviderBalanceSchedulerOut>(
        `/provider-balance-schedulers/${id}/enable`,
      )
      .then((r) => r.data),
  disable: (id: number) =>
    http
      .post<ProviderBalanceSchedulerOut>(
        `/provider-balance-schedulers/${id}/disable`,
      )
      .then((r) => r.data),
  runNow: (id: number) =>
    http
      .post<ProviderBalanceSchedulerOut>(
        `/provider-balance-schedulers/${id}/run-now`,
      )
      .then((r) => r.data),
  // Снять троттлинг повторных алёртов — после пополнения кабинета.
  resetAlerts: (id: number) =>
    http
      .post<ProviderBalanceSchedulerOut>(
        `/provider-balance-schedulers/${id}/reset-alerts`,
      )
      .then((r) => r.data),
  runnerStatus: () =>
    http
      .get<ProviderBalanceSchedulerRunnerStatus>(
        '/provider-balance-schedulers/runner/status',
      )
      .then((r) => r.data),
}

// ---- eSIM EXPIRY NOTIFY SCHEDULERS (раздел «eSIM → Оповещения») ----
//
// Daily-шедулер «срок действия eSIM подошёл к концу». Прогон делает
// отдельный фоновый раннер (api/admin/services/esim_expiry_runner.py),
// сами оповещения — api/client/services/esim_expiry_notifier.py. Этот
// API — управление таблицей esim_expiry_notify_scheduler (CRUD + lifecycle).
export const esimExpirySchedulersApi = {
  list: () =>
    http
      .get<ESimExpiryNotifySchedulerOut[]>('/esim-expiry-schedulers/')
      .then((r) => r.data),
  get: (id: number) =>
    http
      .get<ESimExpiryNotifySchedulerOut>(`/esim-expiry-schedulers/${id}`)
      .then((r) => r.data),
  create: (body: ESimExpiryNotifySchedulerCreate) =>
    http
      .post<ESimExpiryNotifySchedulerOut>('/esim-expiry-schedulers/', body)
      .then((r) => r.data),
  update: (id: number, body: ESimExpiryNotifySchedulerUpdate) =>
    http
      .patch<ESimExpiryNotifySchedulerOut>(
        `/esim-expiry-schedulers/${id}`,
        body,
      )
      .then((r) => r.data),
  delete: (id: number) => http.delete(`/esim-expiry-schedulers/${id}`),
  enable: (id: number) =>
    http
      .post<ESimExpiryNotifySchedulerOut>(
        `/esim-expiry-schedulers/${id}/enable`,
      )
      .then((r) => r.data),
  disable: (id: number) =>
    http
      .post<ESimExpiryNotifySchedulerOut>(
        `/esim-expiry-schedulers/${id}/disable`,
      )
      .then((r) => r.data),
  runNow: (id: number) =>
    http
      .post<ESimExpiryNotifySchedulerOut>(
        `/esim-expiry-schedulers/${id}/run-now`,
      )
      .then((r) => r.data),
  runnerStatus: () =>
    http
      .get<ESimExpiryNotifySchedulerRunnerStatus>(
        '/esim-expiry-schedulers/runner/status',
      )
      .then((r) => r.data),
}

// ---- PAYMENT STATUS SCHEDULERS (раздел «Платежи → Шедулеры») ----
//
// Сверка статусов платежей с эквайрингом: шедулер берёт платежи за
// последние lookback_hours в статусе, отличном от confirmed, спрашивает
// у банка настоящий статус и дожимает зависшие холды
// (authorized → confirmed). Прогон делает фоновый раннер
// api/admin/services/payment_status_runner.py; здесь — CRUD + lifecycle
// таблицы payment_status_scheduler.
export const paymentStatusSchedulersApi = {
  list: () =>
    http
      .get<PaymentStatusSchedulerOut[]>('/payment-status-schedulers/')
      .then((r) => r.data),
  get: (id: number) =>
    http
      .get<PaymentStatusSchedulerOut>(`/payment-status-schedulers/${id}`)
      .then((r) => r.data),
  create: (body: PaymentStatusSchedulerCreate) =>
    http
      .post<PaymentStatusSchedulerOut>('/payment-status-schedulers/', body)
      .then((r) => r.data),
  update: (id: number, body: PaymentStatusSchedulerUpdate) =>
    http
      .patch<PaymentStatusSchedulerOut>(
        `/payment-status-schedulers/${id}`,
        body,
      )
      .then((r) => r.data),
  delete: (id: number) => http.delete(`/payment-status-schedulers/${id}`),
  enable: (id: number) =>
    http
      .post<PaymentStatusSchedulerOut>(
        `/payment-status-schedulers/${id}/enable`,
      )
      .then((r) => r.data),
  disable: (id: number) =>
    http
      .post<PaymentStatusSchedulerOut>(
        `/payment-status-schedulers/${id}/disable`,
      )
      .then((r) => r.data),
  runNow: (id: number) =>
    http
      .post<PaymentStatusSchedulerOut>(
        `/payment-status-schedulers/${id}/run-now`,
      )
      .then((r) => r.data),
  runnerStatus: () =>
    http
      .get<PaymentStatusSchedulerRunnerStatus>(
        '/payment-status-schedulers/runner/status',
      )
      .then((r) => r.data),
}

// ---- «ПЛАТЕЖИ → СКРИПТЫ» ----
//
// Скрипт «Проверить все старые платежи»: превью считаем обычным
// axios-запросом, а сам прогон — NDJSON-стрим (может идти минуты, и
// оператору нужно видеть прогресс, а не спиннер).
export const paymentScriptsApi = {
  previewReconcileAll: (body: PaymentBackfillRequest) =>
    http
      .post<PaymentBackfillPreview>(
        '/payments/scripts/reconcile-all/preview',
        body,
      )
      .then((r) => r.data),
}

export async function streamReconcileAllPayments(
  body: PaymentBackfillRequest,
  opts: {
    token: string | null
    onEvent: (e: PaymentBackfillEvent) => void
    signal?: AbortSignal
  },
): Promise<void> {
  const headers: Record<string, string> = {
    Accept: 'application/x-ndjson',
    'Content-Type': 'application/json',
  }
  if (opts.token) headers.Authorization = `Bearer ${opts.token}`

  const res = await fetch(`${baseURL}/payments/scripts/reconcile-all/stream`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
    signal: opts.signal,
  })
  if (!res.ok || !res.body) {
    let detail = res.statusText
    try {
      const data: any = await res.json()
      if (typeof data?.detail === 'string') detail = data.detail
      else if (Array.isArray(data?.detail))
        detail = data.detail
          .map((d: any) => `${(d.loc ?? []).slice(1).join('.')}: ${d.msg}`)
          .join('\n')
    } catch {
      /* ignore */
    }
    throw new Error(`${res.status} ${detail}`)
  }

  const reader = res.body.getReader()
  const decoder = new TextDecoder('utf-8')
  let buffer = ''
  for (;;) {
    const { done, value } = await reader.read()
    if (done) break
    buffer += decoder.decode(value, { stream: true })
    let nl: number
    while ((nl = buffer.indexOf('\n')) >= 0) {
      const line = buffer.slice(0, nl).trim()
      buffer = buffer.slice(nl + 1)
      if (!line) continue
      try {
        opts.onEvent(JSON.parse(line) as PaymentBackfillEvent)
      } catch (e) {
        console.warn('payment-backfill-stream: bad NDJSON line', line, e)
      }
    }
  }
  const tail = buffer.trim()
  if (tail) {
    try {
      opts.onEvent(JSON.parse(tail) as PaymentBackfillEvent)
    } catch {
      /* ignore */
    }
  }
}

// ---- CLIENT SURVEYS (просмотр ответов клиентов на гибкие опросы) ----
//
// Read-only API: фронт клиентского приложения шлёт ответы через POST
// /surveys/ на КЛИЕНТСКОМ API; admin-API только читает (для аналитики).
// См. api/admin/routers/surveys.py.
export const surveysApi = {
  keys: () => http.get<string[]>('/surveys/keys').then((r) => r.data),
  list: (
    params: {
      user_id?: number
      survey_key?: string
      limit?: number
      offset?: number
    } = {},
  ) =>
    http
      .get<ClientSurveyListOut>('/surveys/', { params })
      .then((r) => r.data),
  get: (id: number) =>
    http.get<ClientSurveyOut>(`/surveys/${id}`).then((r) => r.data),
}

export const auditApi = {
  list: (params: any = {}) =>
    http.get<AuditLogOut[]>('/audit/', { params }).then((r) => r.data),
}

// ---- ADMINS (управление учётками админов; роль superadmin) ----
export interface AdminCreatePayload {
  username: string
  password?: string | null
  full_name?: string | null
  telegram_user_id?: number | null
  role?: string
  // null = полный доступ; массив ключей разделов = ограниченный доступ.
  allowed_sections?: string[] | null
}
export interface AdminUpdatePayload {
  full_name?: string | null
  password?: string | null
  telegram_user_id?: number | null
  role?: string | null
  is_active?: boolean | null
  // Передавать ВМЕСТЕ с allowed_sections_set=true, иначе backend
  // проигнорирует поле (нельзя отличить «не меняли» от «сбросить в null»).
  allowed_sections?: string[] | null
  allowed_sections_set?: boolean
}
export const adminsApi = {
  list: () => http.get<AdminOut[]>('/admins/').then((r) => r.data),
  get: (id: number) => http.get<AdminOut>(`/admins/${id}`).then((r) => r.data),
  sections: () =>
    http.get<AdminSectionOut[]>('/admins/sections').then((r) => r.data),
  create: (data: AdminCreatePayload) =>
    http.post<AdminOut>('/admins/', data).then((r) => r.data),
  update: (id: number, data: AdminUpdatePayload) =>
    http.patch<AdminOut>(`/admins/${id}`, data).then((r) => r.data),
  deactivate: (id: number) => http.delete(`/admins/${id}`),
}

// ---- ACQUIRER TEST PAYMENT ----
export interface AcquirerTestPaymentResponse {
  payment_id: string
  order_id: string
  payment_url: string
  status: string
  amount: number
  currency: string
  acquirer_code?: string
  is_test?: boolean
}
export const acquirerTestApi = {
  // customer_email — куда T-Bank пришлёт чек. Если терминал в ЛК
  // фискальный (54-ФЗ), backend без email вернёт 309. Если оставить
  // пусто, сервер фоллбэчится на system_setting smtp.test_email.
  // taxation/vat_rate — система налогообложения и ставка НДС позиции
  // чека; дефолты `osn`/`none` подходят 99% ИП/ООО.
  test: (
    terminal_id: number,
    body: {
      amount_rub?: number
      description?: string
      customer_email?: string
      taxation?: string
      vat_rate?: string
    } = {},
  ) =>
    http
      .post<AcquirerTestPaymentResponse>(
        `/acquirers/terminals/${terminal_id}/test-payment`,
        body,
      )
      .then((r) => r.data),
}

// ---- SMTP (servers + templates) -----------------------------------------
//
// Раздел «SMTP» в админке. Состоит из трёх UI-вкладок:
//   1. «Сервера»  — CRUD по smtp_server + кнопка «Протестировать».
//   2. «Шаблоны»  — CRUD по smtp_template + превью + тестовая отправка.
//   3. «Настройки» — реализована через settingsApi (`smtp.test_email`,
//                    `client.password_reset_url_template`, etc).
//
// Все запросы автоматически подписываются Bearer-токеном супер-админа
// через axios-инстанс из ./client.

export const smtpApi = {
  // ----- servers -----
  listServers: () => http.get<SMTPServerOut[]>('/smtp/servers').then((r) => r.data),
  createServer: (data: SMTPServerCreate) =>
    http.post<SMTPServerOut>('/smtp/servers', data).then((r) => r.data),
  updateServer: (id: number, data: SMTPServerUpdate) =>
    http.patch<SMTPServerOut>(`/smtp/servers/${id}`, data).then((r) => r.data),
  deleteServer: (id: number) => http.delete(`/smtp/servers/${id}`),
  // POST /smtp/servers/{id}/test — отправляет «hello world» письмо на
  // адрес из smtp.test_email (либо переопределённый to_email). Backend
  // возвращает SMTPSendResultOut: какой шаблон/сервер был использован
  // (для тестовой отправки шаблоном). Если test_email пуст и в body не
  // передали to_email — 400.
  testServer: (id: number, body: SMTPServerTestRequest = {}) =>
    http
      .post<SMTPSendResultOut>(`/smtp/servers/${id}/test`, body)
      .then((r) => r.data),

  // ----- templates -----
  listTemplates: () =>
    http.get<SMTPTemplateOut[]>('/smtp/templates').then((r) => r.data),
  createTemplate: (data: SMTPTemplateCreate) =>
    http.post<SMTPTemplateOut>('/smtp/templates', data).then((r) => r.data),
  updateTemplate: (id: number, data: SMTPTemplateUpdate) =>
    http.patch<SMTPTemplateOut>(`/smtp/templates/${id}`, data).then((r) => r.data),
  // Backend вернёт 409 для is_system=true шаблонов (default_*).
  deleteTemplate: (id: number) => http.delete(`/smtp/templates/${id}`),

  // POST /smtp/templates/preview — отрендерить произвольный черновик
  // (используется в редакторе «как будет выглядеть» до сохранения).
  previewDraft: (body: SMTPTemplatePreviewRequest) =>
    http
      .post<SMTPTemplatePreviewResponse>('/smtp/templates/preview', body)
      .then((r) => r.data),
  // POST /smtp/templates/{id}/preview — то же, но для сохранённого
  // шаблона; в body можно прислать только context, остальное возьмётся
  // из БД.
  previewTemplate: (id: number, body: SMTPTemplatePreviewRequest = {}) =>
    http
      .post<SMTPTemplatePreviewResponse>(`/smtp/templates/${id}/preview`, body)
      .then((r) => r.data),
  // POST /smtp/templates/{id}/test — реально отправить тестовое письмо
  // с demo-контекстом.
  testTemplate: (id: number, body: SMTPTemplateTestRequest = {}) =>
    http
      .post<SMTPSendResultOut>(`/smtp/templates/${id}/test`, body)
      .then((r) => r.data),
}

// ---- SMS (providers + templates + countries) ----------------------------
//
// Раздел «SMS» в админке. Состоит из четырёх UI-вкладок:
//   1. «Агрегаторы» — CRUD по sms_provider + кнопка «Протестировать».
//   2. «Шаблоны»    — CRUD по sms_template + превью + тестовая отправка.
//   3. «Страны»     — whitelist стран (с выбором sms/call для каждой).
//   4. «Настройки»  — реализована через settingsApi (`sms.test_phone`,
//                     `client.require_phone_verification`, `client.send_esim_via_sms`).

export const smsApi = {
  // ----- provider types (поддерживаемые SDK-адаптеры) -----
  // Возвращает {code, display_name, default_base_url, description, supports_voice}
  // для выпадающего списка «выберите тип агрегатора» в форме создания.
  providerTypes: () =>
    http.get<SupportedSMSProvider[]>('/sms/providers/types').then((r) => r.data),

  // ----- providers -----
  listProviders: () =>
    http.get<SMSProviderOut[]>('/sms/providers').then((r) => r.data),
  createProvider: (data: SMSProviderCreate) =>
    http.post<SMSProviderOut>('/sms/providers', data).then((r) => r.data),
  updateProvider: (id: number, data: SMSProviderUpdate) =>
    http.patch<SMSProviderOut>(`/sms/providers/${id}`, data).then((r) => r.data),
  deleteProvider: (id: number) => http.delete(`/sms/providers/${id}`),
  // POST /sms/providers/{id}/test/preview — HTTP-запрос к API агрегатора
  // (без отправки SMS). Секреты в params замаскированы.
  previewProviderTest: (id: number, body: SMSProviderTestRequest = {}) =>
    http
      .post<SMSProviderTestPreviewResponse>(
        `/sms/providers/${id}/test/preview`,
        body,
      )
      .then((r) => r.data),
  // POST /sms/providers/{id}/test — реально отправляет тестовое SMS на
  // sms.test_phone (либо переданный to_phone). Если test_phone пуст и
  // в body не передали to_phone — 400.
  testProvider: (id: number, body: SMSProviderTestRequest = {}) =>
    http
      .post<SMSSendResultOut>(`/sms/providers/${id}/test`, body)
      .then((r) => r.data),

  // POST /sms/providers/{id}/sync — сходить в API агрегатора
  // (smsc.ru /sys/balance.php) и положить актуальный баланс
  // в sms_provider.balance + balance_synced_at.
  syncProvider: (id: number) =>
    http
      .post<SMSProviderSyncResult>(`/sms/providers/${id}/sync`)
      .then((r) => r.data),

  // POST /sms/providers/sync-all — то же самое, но для всех активных
  // агрегаторов разом. Каждого считаем в SAVEPOINT, чтобы один upyac не
  // сорвал остальные.
  syncAllProviders: () =>
    http
      .post<SMSProviderSyncAllResult>('/sms/providers/sync-all')
      .then((r) => r.data),

  // ----- templates -----
  listTemplates: () =>
    http.get<SMSTemplateOut[]>('/sms/templates').then((r) => r.data),
  createTemplate: (data: SMSTemplateCreate) =>
    http.post<SMSTemplateOut>('/sms/templates', data).then((r) => r.data),
  updateTemplate: (id: number, data: SMSTemplateUpdate) =>
    http.patch<SMSTemplateOut>(`/sms/templates/${id}`, data).then((r) => r.data),
  // Backend вернёт 409 для is_system=true шаблонов (default_phone_verification,
  // default_esim_purchased).
  deleteTemplate: (id: number) => http.delete(`/sms/templates/${id}`),

  previewDraft: (body: SMSTemplatePreviewRequest) =>
    http
      .post<SMSTemplatePreviewResponse>('/sms/templates/preview', body)
      .then((r) => r.data),
  previewTemplate: (id: number, body: SMSTemplatePreviewRequest = {}) =>
    http
      .post<SMSTemplatePreviewResponse>(`/sms/templates/${id}/preview`, body)
      .then((r) => r.data),
  testTemplate: (id: number, body: SMSTemplateTestRequest = {}) =>
    http
      .post<SMSSendResultOut>(`/sms/templates/${id}/test`, body)
      .then((r) => r.data),

  // ----- countries -----
  listCountries: () =>
    http.get<SMSCountryOut[]>('/sms/countries').then((r) => r.data),
  createCountry: (data: SMSCountryCreate) =>
    http.post<SMSCountryOut>('/sms/countries', data).then((r) => r.data),
  updateCountry: (id: number, data: SMSCountryUpdate) =>
    http.patch<SMSCountryOut>(`/sms/countries/${id}`, data).then((r) => r.data),
  deleteCountry: (id: number) => http.delete(`/sms/countries/${id}`),
}

// ---- TELEGRAM GATEWAY (раздел «Telegram» — аккаунты gateway.telegram.org) -
//
// API устроен по аналогии с `smsApi` для провайдеров: list / create /
// update / delete + test + sync.
//
// `test` поддерживает два режима:
//   * mode='probe' — checkSendAbility: сообщение НЕ шлётся, дешёво
//     обновляется баланс. По дефолту вызывается кнопкой «Синхр.».
//   * mode='send'  — sendVerificationMessage: на номер придёт настоящий
//     код. Используется кнопкой «Тестовая отправка».
//
// Секреты (`access_token`) — write-only: backend никогда не возвращает
// токен наружу. UI не показывает его в форме редактирования; если поле
// токена пустое в PATCH-body, backend оставляет прежнее значение.

export const telegramGatewayApi = {
  listAccounts: () =>
    http.get<TelegramGatewayAccountOut[]>('/telegram/accounts').then((r) => r.data),
  createAccount: (data: TelegramGatewayAccountCreate) =>
    http
      .post<TelegramGatewayAccountOut>('/telegram/accounts', data)
      .then((r) => r.data),
  updateAccount: (id: number, data: TelegramGatewayAccountUpdate) =>
    http
      .patch<TelegramGatewayAccountOut>(`/telegram/accounts/${id}`, data)
      .then((r) => r.data),
  deleteAccount: (id: number) => http.delete(`/telegram/accounts/${id}`),
  // POST /telegram/accounts/{id}/test — проверка работы аккаунта.
  // mode='probe' — без отправки сообщения. mode='send' — реально шлёт
  // verification-message на `sms.test_phone` (или переданный to_phone).
  testAccount: (id: number, body: TelegramGatewayTestRequest = {}) =>
    http
      .post<TelegramGatewayTestResult>(`/telegram/accounts/${id}/test`, body)
      .then((r) => r.data),
  // POST /telegram/accounts/{id}/sync — checkSendAbility + апдейт баланса.
  // Удобный shortcut для кнопки «Синхр.» в админ-UI. Telegram списывает
  // «маленький» fee за этот вызов (документировано).
  syncAccount: (id: number) =>
    http
      .post<TelegramGatewaySyncResult>(`/telegram/accounts/${id}/sync`)
      .then((r) => r.data),
  // POST /telegram/alerts/test — проверочное сообщение admin-бота в чат
  // из вкладки «Алёрты». chat_id берётся из инпута (до «Сохранить»),
  // ответ содержит название чата — так видно, что id не перепутан.
  testAlertsChat: (body: TelegramAlertTestRequest) =>
    http
      .post<TelegramAlertTestResult>('/telegram/alerts/test', body)
      .then((r) => r.data),
}

// ---- SYSTEM SETTINGS (key-value: reset URL, test email, флаги) ----------
//
// В админке этому соответствует страница «Настройки». Бэкенд
// возвращает только белый список ключей; всё остальное проигнорируется.

export const settingsApi = {
  // GET /settings/ — список всех whitelisted ключей с описаниями.
  list: () => http.get<SystemSettingOut[]>('/settings/').then((r) => r.data),
  // GET /settings/{key} — одно значение. Если ключа ещё нет в БД,
  // backend всё равно вернёт SystemSettingOut с value=null и подсказкой.
  // 404 здесь возможен только от устаревшего backend'а, который ещё
  // не научился возвращать пустышку для неизвестных ключей — подавляем
  // глобальный тост, локальный код в SettingsView сам решит, что делать.
  get: (key: string) =>
    http
      .get<SystemSettingOut>(`/settings/${encodeURIComponent(key)}`, {
        skipErrorToast: (status: number) => status === 404,
      })
      .then((r) => r.data),
  // PATCH /settings/{key} — обновить value (и опционально description).
  // value=null НЕ затирает значение — это семантика «не указано»;
  // чтобы сбросить — передайте пустую строку.
  update: (key: string, data: { value: string | null; description?: string | null }) =>
    http
      .patch<SystemSettingOut>(`/settings/${encodeURIComponent(key)}`, data)
      .then((r) => r.data),

  // GET /settings/topup-providers — блок «Продление трафика».
  //
  // Хранится это одним CSV-ключом (`client.topup_disabled_providers`),
  // но редактируется не текстовым полем: ручка отдаёт справочник
  // агрегаторов с флагом `supports_topup` (умеет ли адаптер продлевать)
  // и уже посчитанным `enabled`, чтобы UI не собирал итог сам.
  topupProviders: () =>
    http.get<TopupProvidersOut>('/settings/topup-providers').then((r) => r.data),
  // PUT /settings/topup-providers — replace-all по списку ВЫКЛЮЧЕННЫХ.
  // Присылаем полный набор кодов: пустой массив включает продление
  // везде, где его поддерживает адаптер. Неизвестный код → 400.
  updateTopupProviders: (data: TopupProvidersUpdate) =>
    http
      .put<TopupProvidersOut>('/settings/topup-providers', data)
      .then((r) => r.data),
  // GET /settings/fallback-providers — блок «Подстановка агрегатора»:
  // режим приоритета, порядок агрегаторов, балансы кабинетов в рублях и
  // очередь подстановки прямо сейчас (effective_order).
  fallbackProviders: () =>
    http.get<FallbackProvidersOut>('/settings/fallback-providers').then((r) => r.data),
  // PUT /settings/fallback-providers — replace-all: режим и полный порядок.
  // Неизвестный код → 400.
  updateFallbackProviders: (data: FallbackProvidersUpdate) =>
    http
      .put<FallbackProvidersOut>('/settings/fallback-providers', data)
      .then((r) => r.data),
}

// ---- CURRENCY RATES (раздел «Настройки» → «Курсы валют») ----------------
//
// Курс хранится × 1_000_000 в BIGINT, но эндпоинты дополнительно возвращают
// `rate` как Decimal-строку (например, "79.450000") — фронт показывает её
// в инпуте, в PATCH отправляет любой из двух форматов (rate или rate_to_rub).

export const currenciesApi = {
  list: () => http.get<CurrencyRateOut[]>('/currencies/rates/').then((r) => r.data),
  get: (currency: string) =>
    http
      .get<CurrencyRateOut>(`/currencies/rates/${encodeURIComponent(currency)}`)
      .then((r) => r.data),
  // PATCH создаёт строку, если её ещё нет (upsert). Передайте либо
  // `rate_to_rub` (целое × 1_000_000), либо `rate` (десятичная строка).
  update: (currency: string, data: CurrencyRateUpdate) =>
    http
      .patch<CurrencyRateOut>(
        `/currencies/rates/${encodeURIComponent(currency)}`,
        data,
      )
      .then((r) => r.data),
  delete: (currency: string) =>
    http.delete(`/currencies/rates/${encodeURIComponent(currency)}`),
  // POST /currencies/rates/sync — спарсить cbr-xml-daily.ru/daily_json.js и
  // обновить курсы. Если currencies не передан — обновляются все валюты,
  // которые уже есть в БД (исключая RUB).
  sync: (body: CurrencyRateSyncRequest = {}) =>
    http
      .post<CurrencyRateSyncResultOut>('/currencies/rates/sync', body)
      .then((r) => r.data),
  // POST /currencies/convert — утилита: пересчитать amount_minor из
  // одной валюты в другую по текущим курсам. Используется UI «живого
  // превью» рядом с настройкой курса.
  convert: (body: CurrencyConvertRequest) =>
    http
      .post<CurrencyConvertResponse>('/currencies/convert', body)
      .then((r) => r.data),
}

// ---- CACHE (раздел «КЭШ» в админ-панели) --------------------------------
//
// Управление Redis-кэшем клиентского API. См. api/admin/routers/cache.py.
// Бэкенд возвращает консистентный снимок Redis + локальных in-memory
// счётчиков — если Redis offline, redis_key_count будет null, а
// connected=false; UI должен в этом случае показать «работаем на
// in-memory fallback».
//
// `target`-параметр определяет, куда обращаемся: `local` — собственный
// процесс admin-API (полезно при one-machine-деплое), `stage`/`prod` —
// HTTP-прокси на соответствующий клиентский API. См. список с
// конфигурацией через `targets()`.

// Хелпер: подмешать `?target=...` к запросу. Если значение пусто или
// равно дефолту — query-param НЕ добавляем (для бэкенда дефолт =
// `local`, нам не нужны лишние URL-параметры).
const withTarget = (
  params: Record<string, unknown> | undefined,
  target?: CacheTarget,
): Record<string, unknown> | undefined => {
  if (!target || target === 'local') return params
  return { ...(params ?? {}), target }
}

export const cacheApi = {
  // GET /cache/targets — список доступных таргетов (local/stage/prod) +
  // статус «настроен ли URL/secret».
  targets: () =>
    http.get<CacheTargetsOut>('/cache/targets').then((r) => r.data),

  // GET /cache/ — статус Redis + все категории со статистикой.
  status: (target?: CacheTarget) =>
    http
      .get<CacheStatusOut>('/cache/', { params: withTarget(undefined, target) })
      .then((r) => r.data),

  // GET /cache/health — короткий health-check (для дашборда).
  health: (target?: CacheTarget) =>
    http
      .get<CacheHealthOut>('/cache/health', {
        params: withTarget(undefined, target),
      })
      .then((r) => r.data),

  // GET /cache/{category}/keys — список ключей в категории (с TTL и size).
  listKeys: (category: string, limit = 50, target?: CacheTarget) =>
    http
      .get<CacheKeysPage>(`/cache/${encodeURIComponent(category)}/keys`, {
        params: withTarget({ limit }, target),
      })
      .then((r) => r.data),

  // PATCH /cache/{category} — изменить TTL категории. 0/null = сбросить
  // override и вернуть дефолт.
  updateTTL: (category: string, body: CacheTTLUpdate, target?: CacheTarget) =>
    http
      .patch<CacheCategoryStatsOut>(
        `/cache/${encodeURIComponent(category)}`,
        body,
        { params: withTarget(undefined, target) },
      )
      .then((r) => r.data),

  // POST /cache/{category}/invalidate — сбросить все ключи категории.
  invalidate: (category: string, target?: CacheTarget) =>
    http
      .post<CacheInvalidateResult>(
        `/cache/${encodeURIComponent(category)}/invalidate`,
        undefined,
        { params: withTarget(undefined, target) },
      )
      .then((r) => r.data),

  // POST /cache/invalidate-all — полная очистка (только ключи с нашим
  // REDIS_KEY_PREFIX, чтобы не задеть соседей).
  invalidateAll: (target?: CacheTarget) =>
    http
      .post<CacheInvalidateResult>('/cache/invalidate-all', undefined, {
        params: withTarget(undefined, target),
      })
      .then((r) => r.data),

  // POST /cache/{category}/warmup — прогреть конкретную категорию.
  warmupCategory: (category: string, target?: CacheTarget) =>
    http
      .post<CacheWarmupResultOut>(
        `/cache/${encodeURIComponent(category)}/warmup`,
        undefined,
        { params: withTarget(undefined, target) },
      )
      .then((r) => r.data),

  // POST /cache/warmup-all — прогреть все warmupable-категории.
  warmupAll: (target?: CacheTarget) =>
    http
      .post<CacheWarmupReportOut>('/cache/warmup-all', undefined, {
        params: withTarget(undefined, target),
      })
      .then((r) => r.data),
}

// ---------------------------------------------------------------------------
// Подписчики клиентского бота и маркетинговые рассылки
// ---------------------------------------------------------------------------
//
// Эти эндпоинты обслуживают раздел "Рассылка" в SPA. Сами отправки
// делает воркер внутри Telegram-бота — admin-API только пишет
// PENDING-задание в БД и читает прогресс.

export const botSubscribersApi = {
  // GET /bot/subscribers/stats — счётчики для дашборда "Рассылка".
  //
  // 404 здесь возможен в окне deploy (старый admin-API ещё не знает
  // про /bot/subscribers/*) — подавляем глобальный тост, чтобы UI не
  // ругался, а просто оставался с пустыми счётчиками; локальный
  // BroadcastsView в этом случае рендерит EmptyState.
  stats: () =>
    http
      .get<import('./types').BotSubscriberStats>('/bot/subscribers/stats', {
        skipErrorToast: (status: number) => status === 404,
      })
      .then((r) => r.data),

  // GET /bot/subscribers — пагинированный список с фильтрами.
  list: (params: {
    offset?: number
    limit?: number
    is_active?: boolean | null
    has_app_user?: boolean | null
    search?: string
  } = {}) =>
    http
      .get<import('./types').BotSubscriberListOut>('/bot/subscribers/', {
        params,
        skipErrorToast: (status: number) => status === 404,
      })
      .then((r) => r.data),
}

export const broadcastsApi = {
  // GET /broadcasts/ — список рассылок (новые сверху). Можно фильтровать
  // по статусу: `?status=running&status=pending`.
  list: (params: {
    offset?: number
    limit?: number
    status?: import('./types').BroadcastStatus[]
  } = {}) =>
    http
      .get<import('./types').BroadcastListOut>('/broadcasts/', {
        params,
      })
      .then((r) => r.data),

  // GET /broadcasts/{id} — детальный прогресс. SPA опрашивает раз в
  // 2–3 секунды, пока статус == running/cancelling, для живого
  // прогресс-бара.
  get: (id: number) =>
    http
      .get<import('./types').BroadcastOut>(`/broadcasts/${id}`)
      .then((r) => r.data),

  // POST /broadcasts/ — создать массовую рассылку (PENDING).
  // Воркер бота заберёт её в ближайшие ~5 секунд.
  create: (body: import('./types').BroadcastCreate) =>
    http
      .post<import('./types').BroadcastOut>('/broadcasts/', body)
      .then((r) => r.data),

  // POST /broadcasts/test — тестовая рассылка на один tg_id.
  // Если `test_telegram_id` в body не передан, backend возьмёт из
  // системной настройки `admin.broadcast_test_telegram_id`.
  createTest: (body: import('./types').BroadcastTestCreate) =>
    http
      .post<import('./types').BroadcastOut>('/broadcasts/test', body)
      .then((r) => r.data),

  // POST /broadcasts/{id}/cancel — попросить воркера остановиться.
  // PENDING → CANCELLED моментально; RUNNING → CANCELLING (воркер
  // увидит на следующей итерации и переведёт в CANCELLED).
  cancel: (id: number) =>
    http
      .post<import('./types').BroadcastOut>(`/broadcasts/${id}/cancel`)
      .then((r) => r.data),

  // GET /broadcasts/{id}/stats — отчёт по кампании. Считается живыми
  // запросами, поэтому «дозревает»: клики приходят в первые часы,
  // покупки — днями. Кнопка «Обновить» в UI дёргает именно это.
  stats: (id: number) =>
    http
      .get<import('./types').BroadcastStats>(`/broadcasts/${id}/stats`)
      .then((r) => r.data),

  // GET /broadcasts/audience/options — справочники фильтров, языки
  // подписчиков, готовые сегменты и виды кнопок. Подписи приходят с
  // бэкенда: добавили состояние в broadcast/audience.py — оно само
  // появилось в выпадающем списке, без правок SPA.
  audienceOptions: () =>
    http
      .get<import('./types').BroadcastAudienceOptions>(
        '/broadcasts/audience/options',
      )
      .then((r) => r.data),

  // POST /broadcasts/audience/preview — «сколько получателей и кто
  // это». Дёргается из редактора с дебаунсом при каждой правке
  // фильтров: до запуска админ обязан видеть размер сегмента.
  audiencePreview: (body: {
    audience: import('./types').BroadcastAudience
    sample_size?: number
  }) =>
    http
      .post<import('./types').BroadcastAudiencePreview>(
        '/broadcasts/audience/preview',
        body,
      )
      .then((r) => r.data),
}

// Шаблоны рассылок: CRUD под /broadcasts/templates/*.
// Используются на табах «Шаблоны» (CRUD) и «Скрипты» (выбор шаблона
// + запуск).
export const broadcastTemplatesApi = {
  // 404 на list возможен в окне deploy (старый admin-API ещё не знает
  // про /broadcasts/templates) — подавляем глобальный тост; UI
  // покажет таб «Шаблоны» в EmptyState. Локальный catch в
  // BroadcastsView дополнительно ставит loadingTemplates=false.
  list: (params: { search?: string; offset?: number; limit?: number } = {}) =>
    http
      .get<import('./types').BroadcastTemplateListOut>(
        '/broadcasts/templates',
        {
          params,
          skipErrorToast: (status: number) => status === 404,
        },
      )
      .then((r) => r.data),

  get: (id: number) =>
    http
      .get<import('./types').BroadcastTemplateOut>(
        `/broadcasts/templates/${id}`,
      )
      .then((r) => r.data),

  create: (body: import('./types').BroadcastTemplateCreate) =>
    http
      .post<import('./types').BroadcastTemplateOut>(
        '/broadcasts/templates',
        body,
      )
      .then((r) => r.data),

  update: (
    id: number,
    body: import('./types').BroadcastTemplateUpdate,
  ) =>
    http
      .patch<import('./types').BroadcastTemplateOut>(
        `/broadcasts/templates/${id}`,
        body,
      )
      .then((r) => r.data),

  // 204 No Content при успехе; в случае ошибки axios-interceptor
  // покажет тост.
  remove: (id: number) =>
    http.delete(`/broadcasts/templates/${id}`),
}

// Раздел «Тест»: диагностика выпуска eSIM у SmartCard (подбор формата
// e-mail покупателя). Запускается с сервера, чей IP в whitelist'е
// SmartCard. Backend — api/admin/routers/test.py.
export const testApi = {
  // GET /test/smartcard/accounts — активные SmartCard-аккаунты (источник кредов).
  smartcardAccounts: () =>
    http
      .get<import('./types').SmartCardTestAccount[]>('/test/smartcard/accounts')
      .then((r) => r.data),

  // GET /test/smartcard/accounts/{id}/plans — провайдер-планы для выбора
  // external_plan_id (опциональный поиск по q).
  smartcardPlans: (accountId: number, q?: string, limit = 20) =>
    http
      .get<import('./types').SmartCardTestPlan[]>(
        `/test/smartcard/accounts/${accountId}/plans`,
        { params: { q: q || undefined, limit } },
      )
      .then((r) => r.data),

  // POST /test/smartcard/probe-email — реальная проба выпуска eSIM разными
  // способами доставки e-mail. ВНИМАНИЕ: верный вариант выпускает реальную
  // eSIM и списывает её стоимость (см. backend-докстринг).
  smartcardProbeEmail: (body: import('./types').SmartCardEmailProbeRequest) =>
    http
      .post<import('./types').SmartCardEmailProbeResult>(
        '/test/smartcard/probe-email',
        body,
        // Проба может идти долго (перебор вариантов с реальными
        // round-trip'ами к SmartCard) — поднимаем таймаут.
        { timeout: 120000 },
      )
      .then((r) => r.data),
}

// ---- FINANCE (раздел «Финансы») -----------------------------------------
//
// Партнёры (доли чистой выручки), операционные расходы (temporary /
// percent / metered) и ежедневный финансовый отчёт + его шедулер-алёрт.
// См. api/admin/routers/finance.py.
export const financeApi = {
  // Партнёры
  listPartners: (includeInactive = false) =>
    http
      .get<FinancePartnerOut[]>('/finance/partners', {
        params: { include_inactive: includeInactive },
      })
      .then((r) => r.data),
  createPartner: (body: FinancePartnerCreate) =>
    http.post<FinancePartnerOut>('/finance/partners', body).then((r) => r.data),
  updatePartner: (id: number, body: FinancePartnerUpdate) =>
    http
      .patch<FinancePartnerOut>(`/finance/partners/${id}`, body)
      .then((r) => r.data),
  deletePartner: (id: number) => http.delete(`/finance/partners/${id}`),

  // Расходы
  listExpenses: (includeInactive = false) =>
    http
      .get<FinanceExpenseOut[]>('/finance/expenses', {
        params: { include_inactive: includeInactive },
      })
      .then((r) => r.data),
  createExpense: (body: FinanceExpenseCreate) =>
    http.post<FinanceExpenseOut>('/finance/expenses', body).then((r) => r.data),
  parseExpenses: () =>
    http
      .post<FinanceExpenseOut[]>('/finance/expenses/parse')
      .then((r) => r.data),
  updateExpense: (id: number, body: FinanceExpenseUpdate) =>
    http
      .patch<FinanceExpenseOut>(`/finance/expenses/${id}`, body)
      .then((r) => r.data),
  deleteExpense: (id: number) => http.delete(`/finance/expenses/${id}`),

  // Отчёт. `date` — ISO YYYY-MM-DD (по московскому календарю); опускаем
  // = сегодня (тогда отчёт partial=true).
  report: (date?: string) =>
    http
      .get<FinanceReportOut>('/finance/report', {
        params: date ? { date } : undefined,
      })
      .then((r) => r.data),
  reportHistory: (limit = 30) =>
    http
      .get<FinanceReportOut[]>('/finance/report/history', { params: { limit } })
      .then((r) => r.data),

  // Шедулер ежедневного алёрта
  getScheduler: () =>
    http.get<FinanceReportSchedulerOut>('/finance/scheduler').then((r) => r.data),
  updateScheduler: (body: FinanceReportSchedulerUpdate) =>
    http
      .patch<FinanceReportSchedulerOut>('/finance/scheduler', body)
      .then((r) => r.data),
  runSchedulerNow: () =>
    http
      .post<FinanceReportSchedulerOut>('/finance/scheduler/run-now')
      .then((r) => r.data),
  runnerStatus: () =>
    http
      .get<FinanceReportRunnerStatus>('/finance/scheduler/runner/status')
      .then((r) => r.data),

  // Интеграция расходов мастер-панели VPN. `probe=false` — только
  // локальное состояние, без сетевого вызова на ту сторону.
  costIntegrationStatus: (probe = true) =>
    http
      .get<CostIntegrationStatusOut>('/finance/cost-integration/status', {
        params: { probe },
      })
      .then((r) => r.data),
  saveCostIntegration: (body: CostIntegrationSettingsUpdate) =>
    http
      .put<CostIntegrationStatusOut>('/finance/cost-integration/settings', body)
      .then((r) => r.data),
  syncCostIntegration: () =>
    http
      .post<CostIntegrationSyncOut>('/finance/cost-integration/sync')
      .then((r) => r.data),
  createRemoteCost: (body: CostIntegrationCostCreate) =>
    http
      .post<CostIntegrationCostCreateOut>(
        '/finance/cost-integration/costs',
        body,
      )
      .then((r) => r.data),

  // Рекламные кабинеты. `probe=false` (дефолт) — только локальное
  // состояние: вкладка открывается часто, а проверка токена — сетевой
  // вызов в каждый кабинет.
  adIntegrations: (probe = false) =>
    http
      .get<AdIntegrationOut[]>('/finance/integrations', { params: { probe } })
      .then((r) => r.data),
  saveAdIntegration: (provider: string, body: AdIntegrationUpdate) =>
    http
      .put<AdIntegrationOut>(`/finance/integrations/${provider}`, body)
      .then((r) => r.data),
  runAdIntegration: (provider: string, spendDate?: string) =>
    http
      .post<AdIntegrationRunOut>(
        `/finance/integrations/${provider}/run`,
        undefined,
        { params: spendDate ? { spend_date: spendDate } : undefined },
      )
      .then((r) => r.data),
  // Забрать расход за день и показать его, НЕ записывая деньгами —
  // то же, что делает поллер.
  previewAdIntegration: (provider: string, spendDate?: string) =>
    http
      .post<AdIntegrationRunOut>(
        `/finance/integrations/${provider}/preview`,
        undefined,
        { params: spendDate ? { spend_date: spendDate } : undefined },
      )
      .then((r) => r.data),

  // Поллер интеграций: частота, с которой освежаются данные обеих
  // интеграций между ежедневными отчётами.
  getPoller: () =>
    http.get<FinanceIntegrationPollerOut>('/finance/poller').then((r) => r.data),
  updatePoller: (body: FinanceIntegrationPollerUpdate) =>
    http
      .patch<FinanceIntegrationPollerOut>('/finance/poller', body)
      .then((r) => r.data),
  runPollerNow: () =>
    http
      .post<FinanceIntegrationPollerOut>('/finance/poller/run-now')
      .then((r) => r.data),

  // Финансы Яндекс Маркета: комиссии, продвижение и премия по дням.
  // `probe` ходит в Маркет и проверяет, видит ли ключ наш магазин.
  marketFinance: (probe = false) =>
    http
      .get<MarketFinanceOut>('/finance/market', { params: { probe } })
      .then((r) => r.data),
  saveMarketFinance: (body: MarketFinanceUpdate) =>
    http.put<MarketFinanceOut>('/finance/market', body).then((r) => r.data),
  // Перечитывает окно дней целиком: Маркет дописывает начисления задним
  // числом, поэтому повторный синк — норма, а не исключение.
  syncMarketFinance: (days?: number) =>
    http
      .post<MarketFinanceRunOut>('/finance/market/sync', undefined, {
        params: days ? { days } : undefined,
      })
      .then((r) => r.data),

  // Таблица «Стат. по расходам». Период по умолчанию — текущий месяц;
  // считается на лету, снапшотов у неё нет.
  stats: (start?: string, end?: string) =>
    http
      .get<FinanceStatsOut>('/finance/stats', {
        params: { start: start || undefined, end: end || undefined },
      })
      .then((r) => r.data),
  saveStatsSettings: (body: FinanceStatsSettingsUpdate) =>
    http
      .put<FinanceStatsSettingsOut>('/finance/stats/settings', body)
      .then((r) => r.data),
}

// ---- REPORTS (раздел «Отчёты») -------------------------------------------
//
// Один клиент на все подразделы: ключ отчёта (`esim` / `plans` /
// `payments` / `discounts`) — просто параметр пути. Конструктор
// рисуется по мете, поэтому фронт не знает ничего про конкретные
// фильтры. См. api/admin/routers/reports.py.
export const reportsApi = {
  // Карточки подразделов. Отчёты, закрытые правами, бэкенд из списка
  // убирает — меню строится ровно по тому, что вернулось.
  kinds: () => http.get<ReportKindsOut>('/reports/').then((r) => r.data),

  // Описание конструктора: колонки, пресеты, поля фильтров, справочники
  // (страны/тарифы/эквайринги), форматы, языки и лимиты. Тянется один
  // раз при открытии подраздела: подписи приходят парой {ru, en}, так
  // что переключение языка не требует повторного запроса.
  meta: (reportKey: string) =>
    http.get<ReportMetaOut>(`/reports/${reportKey}/meta`).then((r) => r.data),

  // Предпросмотр: страница строк + итоги + расшифровка фильтров, без
  // формирования файла.
  preview: (reportKey: string, body: ReportPreviewRequest) =>
    http
      .post<ReportPreviewOut>(`/reports/${reportKey}/preview`, body, {
        // Тяжёлые фильтры (агрегаты по платежам) считаются дольше
        // дефолтных 30 секунд.
        timeout: 120_000,
      })
      .then((r) => r.data),

  // Файл отчёта. Ответ бинарный (XLSX/PDF) → responseType=blob; имя
  // берём из Content-Disposition (заголовок открыт для JS через CORS
  // expose_headers, см. api/admin/main.py).
  export: (reportKey: string, body: ReportExportRequest) =>
    http
      .post<Blob>(`/reports/${reportKey}/export`, body, {
        responseType: 'blob',
        // Десятки тысяч строк рендерятся синхронно в запросе.
        timeout: 300_000,
      })
      .then((r) => ({
        blob: r.data,
        filename: filenameFromDisposition(
          r.headers['content-disposition'] as string | undefined,
          `${reportKey}_report.${body.format}`,
        ),
      })),

  // Сохранённые настройки конструктора: свои + общие чужие.
  templates: (reportKey: string, search?: string) =>
    http
      .get<ReportTemplateListOut>(`/reports/${reportKey}/templates`, {
        params: { search: search || undefined },
      })
      .then((r) => r.data),
  createTemplate: (reportKey: string, body: ReportTemplateCreate) =>
    http
      .post<ReportTemplateOut>(`/reports/${reportKey}/templates`, body)
      .then((r) => r.data),
  updateTemplate: (templateId: number, body: ReportTemplateUpdate) =>
    http
      .patch<ReportTemplateOut>(`/reports/templates/${templateId}`, body)
      .then((r) => r.data),
  deleteTemplate: (templateId: number) =>
    http.delete(`/reports/templates/${templateId}`),

  // ---- Аналитика: графики и сводные таблицы вместо файла ----

  // Что можно посчитать по отчёту: метрики (колонка + агрегация), оси,
  // шаги оси, виды графиков. Фильтры сюда не дублируются — их отдаёт
  // `meta()`, и конструктор графика рисует ту же форму.
  analyticsMeta: (reportKey: string) =>
    http
      .get<ReportAnalyticsMetaOut>(`/reports/${reportKey}/analytics/meta`)
      .then((r) => r.data),

  // Сами агрегаты. Считаются по строкам отчёта, поэтому по времени
  // сопоставимы с предпросмотром, а не с мгновенным GROUP BY.
  analytics: (reportKey: string, body: ReportAnalyticsRequest) =>
    http
      .post<ReportAnalyticsOut>(`/reports/${reportKey}/analytics`, body, {
        timeout: 120_000,
      })
      .then((r) => r.data),

  // ---- Сохранённые графики ----

  charts: (reportKey: string, search?: string) =>
    http
      .get<ReportChartListOut>(`/reports/${reportKey}/charts`, {
        params: { search: search || undefined },
      })
      .then((r) => r.data),
  createChart: (reportKey: string, body: ReportChartCreate) =>
    http
      .post<ReportChartOut>(`/reports/${reportKey}/charts`, body)
      .then((r) => r.data),
  updateChart: (chartId: number, body: ReportChartUpdate) =>
    http
      .patch<ReportChartOut>(`/reports/charts/${chartId}`, body)
      .then((r) => r.data),
  deleteChart: (chartId: number) => http.delete(`/reports/charts/${chartId}`),

  // Пересчёт сохранённого графика по НАСТРОЙКЕ ИЗ БД: тело запроса не
  // участвует, поэтому чужой график нельзя подменить своим конфигом.
  chartData: (chartId: number) =>
    http
      .post<ReportChartDataOut>(`/reports/charts/${chartId}/data`, undefined, {
        timeout: 120_000,
      })
      .then((r) => r.data),
}

// ==========================================================================
// PUSH (раздел «Push»)
// ==========================================================================
//
// Backend — `api/admin/routers/push.py`. Отправку в Firebase делает
// `push/` + `api/client/services/notifications.py`; отсюда только
// управление и диагностика.

export const pushApi = {
  /** Состояние FCM + счётчики для таба «Обзор». */
  overview: () =>
    http
      .get<import('./types').PushOverviewOut>('/push/overview')
      .then((r) => r.data),

  /** Реестр событий с действующими текстами и превью. */
  events: () =>
    http
      .get<import('./types').PushEventListOut>('/push/events')
      .then((r) => r.data),

  /** Пустая строка в `*_template` = вернуть заводской текст. */
  updateEvent: (
    eventType: string,
    body: import('./types').PushEventUpdate,
  ) =>
    http
      .patch<import('./types').PushEventOut>(
        `/push/events/${encodeURIComponent(eventType)}`,
        body,
      )
      .then((r) => r.data),

  /**
   * Настройки поллера напоминаний о неоплаченной форме — карточка на том
   * же табе, что и тумблеры событий `payment.unpaid_reminder` и
   * `payment.form_expired`.
   */
  paymentReminders: () =>
    http
      .get<import('./types').PaymentReminderSettingsOut>(
        '/push/payment-reminders',
      )
      .then((r) => r.data),

  updatePaymentReminders: (
    body: import('./types').PaymentReminderSettingsUpdate,
  ) =>
    http
      .patch<import('./types').PaymentReminderSettingsOut>(
        '/push/payment-reminders',
        body,
      )
      .then((r) => r.data),

  // Прогон делает фоновый раннер — ручка только ставит отметку, поэтому
  // возвращается мгновенно, а результат вью дочитывает опросом.
  runPaymentReminders: () =>
    http
      .post<import('./types').PaymentReminderSettingsOut>(
        '/push/payment-reminders/run',
      )
      .then((r) => r.data),

  // Отправка СИНХРОННАЯ (ждём ответ FCM), поэтому таймаут больше
  // дефолтных 30s: мультикаст на несколько устройств + холодная
  // инициализация SDK на первом запросе после рестарта.
  //
  // Провал отправки приезжает как 200 с `error` в теле, а не как 4xx:
  // «токен мёртв» — это результат диагностики, а не ошибка запроса.
  // Поэтому глобальный тост тут не нужен, вью показывает результат сам.
  test: (body: import('./types').PushTestIn = {}) =>
    http
      .post<import('./types').PushSendResultOut>('/push/test', body, {
        timeout: 60_000,
      })
      .then((r) => r.data),

  broadcast: (body: import('./types').PushBroadcastIn) =>
    http
      .post<import('./types').PushBroadcastOut>('/push/broadcast', body, {
        timeout: 120_000,
      })
      .then((r) => r.data),

  devices: (
    params: {
      user_id?: number
      platform?: import('./types').DevicePlatform
      limit?: number
      offset?: number
    } = {},
  ) =>
    http
      .get<import('./types').PushDeviceListOut>('/push/devices', { params })
      .then((r) => r.data),

  deleteDevice: (deviceId: string) =>
    http.delete(`/push/devices/${encodeURIComponent(deviceId)}`),

  // `type` и `push_status` — массивы: axios сериализует их повторяющимися
  // ключами (`?push_status=sent&push_status=failed`), как ждёт FastAPI.
  notifications: (
    params: {
      user_id?: number
      type?: string[]
      push_status?: import('./types').PushStatus[]
      since?: string
      until?: string
      unread_only?: boolean
      limit?: number
      offset?: number
    } = {},
  ) =>
    http
      .get<import('./types').PushNotificationListOut>('/push/notifications', {
        params,
      })
      .then((r) => r.data),
}

// «Отчёты → Снимки»: реплика выбранных таблиц боевой базы во внешний
// Postgres по расписанию. Здесь только управление приёмниками — сам
// налив делает фоновый раннер внутри admin-API, поэтому `runNow`
// возвращается мгновенно, а прогресс UI дочитывает опросом списка.
//
// Пароль приёмника backend не отдаёт никогда: в `SnapshotTargetOut`
// лежит только `has_password`.
export const snapshotsApi = {
  list: () =>
    http
      .get<import('./types').SnapshotTargetOut[]>('/snapshots/')
      .then((r) => r.data),

  create: (data: import('./types').SnapshotTargetCreate) =>
    http
      .post<import('./types').SnapshotTargetOut>('/snapshots/', data)
      .then((r) => r.data),

  update: (
    targetId: number,
    data: import('./types').SnapshotTargetUpdate,
  ) =>
    http
      .patch<import('./types').SnapshotTargetOut>(
        `/snapshots/${targetId}`,
        data,
      )
      .then((r) => r.data),

  delete: (targetId: number) => http.delete(`/snapshots/${targetId}`),

  setEnabled: (targetId: number, isEnabled: boolean) =>
    http
      .put<import('./types').SnapshotTargetOut>(
        `/snapshots/${targetId}/enabled`,
        { is_enabled: isEnabled },
      )
      .then((r) => r.data),

  runNow: (targetId: number) =>
    http
      .post<import('./types').SnapshotTargetOut>(
        `/snapshots/${targetId}/run-now`,
        {},
      )
      .then((r) => r.data),

  // Динамический состав снимка: список строится интроспекцией живой
  // схемы источника, а не захардкожен ни здесь, ни на бэкенде.
  sourceTables: () =>
    http
      .get<import('./types').SnapshotSourceTablesOut>(
        '/snapshots/source-tables',
      )
      .then((r) => r.data),

  // Колонки одной таблицы — тоже из живой схемы. Грузятся по требованию
  // (когда оператор открывает состав таблицы), а не пачкой на все
  // таблицы сразу: схема проекта — это сотни колонок.
  sourceColumns: (table: string) =>
    http
      .get<import('./types').SnapshotSourceColumnsOut>(
        '/snapshots/source-columns',
        { params: { table } },
      )
      .then((r) => r.data),

  // Проверка реквизитов из формы (ещё не сохранённых). Ответ всегда
  // 200 с полем `ok` — «не подключились» это нормальный результат
  // проверки, а не ошибка запроса, поэтому глушим тост интерцептора.
  test: (data: import('./types').SnapshotConnectionTestIn) =>
    http
      .post<import('./types').SnapshotConnectionTestOut>(
        '/snapshots/test',
        data,
        { timeout: 60_000 },
      )
      .then((r) => r.data),

  testSaved: (targetId: number) =>
    http
      .post<import('./types').SnapshotConnectionTestOut>(
        `/snapshots/${targetId}/test`,
        {},
        { timeout: 60_000 },
      )
      .then((r) => r.data),

  runs: (params: { target_id?: number; limit?: number; offset?: number } = {}) =>
    http
      .get<import('./types').SnapshotRunListOut>('/snapshots/runs', { params })
      .then((r) => r.data),

  runnerStatus: () =>
    http
      .get<import('./types').SnapshotRunnerStatusOut>('/snapshots/runner/status')
      .then((r) => r.data),
}

// «Отчёты → Лог посещений»: переходы с рекламы на лендинг. Read-only —
// строки пишет КЛИЕНТСКОЕ API (`POST /marketing/visits`), админка их
// только читает.
//
// `list` и `stats` принимают ОДИН и тот же набор фильтров (`VisitLogFilterParams`)
// и должны зваться с одинаковым объектом: иначе числа в шапке посчитаются
// по одной выборке, а лента покажет другую.
export const visitLogApi = {
  list: (
    params: import('./types').VisitLogFilterParams & {
      limit?: number
      offset?: number
    } = {},
  ) =>
    http
      .get<import('./types').VisitLogListOut>('/visit-log/', { params })
      .then((r) => r.data),

  stats: (
    params: import('./types').VisitLogFilterParams & {
      /** Измерение разбивки, по умолчанию `utm_source`. */
      group_by?: string
      group_limit?: number
      /** Сколько последних суток показать на графике. */
      days?: number
    } = {},
  ) =>
    http
      .get<import('./types').VisitLogStatsOut>('/visit-log/stats', { params })
      .then((r) => r.data),

  filters: () =>
    http
      .get<import('./types').VisitLogFiltersOut>('/visit-log/filters')
      .then((r) => r.data),
}

// «Тарифы → История цен»: журнал «было → стало» по цене и наценке.
// Read-only — строки пишет ORM-слушатель на бэкенде при ЛЮБОЙ правке
// тарифа (карточка, скрипт наценки, таблица маркетолога, парсер).
//
// `list`, `stats` и `exportFile` принимают ОДИН набор фильтров
// (`PlanPriceHistoryFilterParams`) и должны зваться одинаковым объектом:
// иначе шапка посчитается по одной выборке, лента покажет другую, а в
// файл уедет третья. Массив `sources` уходит повтором имени параметра —
// см. paramsSerializer в client.ts.
export const planPriceHistoryApi = {
  list: (
    params: import('./types').PlanPriceHistoryFilterParams & {
      limit?: number
      offset?: number
    } = {},
  ) =>
    http
      .get<import('./types').PlanPriceHistoryListOut>('/plan-price-history/', {
        params,
      })
      .then((r) => r.data),

  stats: (
    params: import('./types').PlanPriceHistoryFilterParams & {
      /** Сколько тарифов показать в топе «чаще всего меняли». */
      plans_limit?: number
      /** Сколько последних суток показать на графике. */
      days?: number
    } = {},
  ) =>
    http
      .get<import('./types').PlanPriceHistoryStatsOut>(
        '/plan-price-history/stats',
        { params },
      )
      .then((r) => r.data),

  filters: () =>
    http
      .get<import('./types').PlanPriceHistoryFiltersOut>(
        '/plan-price-history/filters',
      )
      .then((r) => r.data),

  // Вся история ОДНОГО тарифа — для окна «Показать историю» из списка
  // тарифов. Без фильтров ленты: смотрят путь цены целиком.
  forPlan: (planId: number, params: { limit?: number } = {}) =>
    http
      .get<import('./types').PlanPriceHistoryListOut>(
        `/plan-price-history/plans/${planId}`,
        { params },
      )
      .then((r) => r.data),

  // Файл. Ответ бинарный (XLSX/PDF) → responseType=blob; имя берём из
  // Content-Disposition (заголовок открыт для JS через CORS
  // expose_headers, см. api/admin/main.py).
  exportFile: (body: import('./types').PlanPriceHistoryExportRequest) =>
    http
      .post<Blob>('/plan-price-history/export', body, {
        responseType: 'blob',
        // Десятки тысяч строк рендерятся синхронно в запросе.
        timeout: 300_000,
      })
      .then((r) => ({
        blob: r.data,
        filename: filenameFromDisposition(
          r.headers['content-disposition'] as string | undefined,
          `plan_price_history.${body.format}`,
        ),
      })),
}

// Раздел «Маркетплейсы»: продажа тарифов eSIM на внешних витринах.
//
// Действия над карточкой (`listingAction`) НЕ ходят в сеть синхронно —
// они меняют намерение (`desired_status`) и будят фоновый раннер. Поэтому
// кнопка отрабатывает мгновенно и не зависит от того, жив ли сейчас Ozon,
// а UI дочитывает фактическое состояние опросом списка.
//
// Исключение — `sync`: там админ осознанно ждёт результат, и запрос может
// идти десятки секунд. Для «поставить в очередь и не ждать» есть
// `sync(id, { background: true })`, а для «ждать и видеть ход работ» —
// `streamSyncMarketplaceAccount` ниже.
export const marketplacesApi = {
  list: () =>
    http
      .get<import('./types').MarketplaceListOut>('/marketplaces/')
      .then((r) => r.data),

  runnerStatus: () =>
    http
      .get<import('./types').MarketplaceRunnerStatusOut>(
        '/marketplaces/runner/status',
      )
      .then((r) => r.data),

  // ---- кабинеты ----

  createAccount: (data: import('./types').MarketplaceAccountCreate) =>
    http
      .post<import('./types').MarketplaceAccountOut>(
        '/marketplaces/accounts',
        data,
      )
      .then((r) => r.data),

  getAccount: (accountId: number) =>
    http
      .get<import('./types').MarketplaceAccountOut>(
        `/marketplaces/accounts/${accountId}`,
      )
      .then((r) => r.data),

  updateAccount: (
    accountId: number,
    data: import('./types').MarketplaceAccountUpdate,
  ) =>
    http
      .patch<import('./types').MarketplaceAccountOut>(
        `/marketplaces/accounts/${accountId}`,
        data,
      )
      .then((r) => r.data),

  deleteAccount: (accountId: number) =>
    http.delete(`/marketplaces/accounts/${accountId}`),

  checkAccount: (accountId: number) =>
    http
      .post<import('./types').MarketplaceCheckOut>(
        `/marketplaces/accounts/${accountId}/check`,
      )
      .then((r) => r.data),

  sync: (accountId: number, params: { background?: boolean } = {}) =>
    http
      .post<import('./types').MarketplaceSyncOut>(
        `/marketplaces/accounts/${accountId}/sync`,
        null,
        // Прогон кабинета с сотнями карточек — это сотни HTTP-запросов к
        // площадке; дефолтного таймаута клиента на него не хватает.
        { params, timeout: params.background ? undefined : 300_000 },
      )
      .then((r) => r.data),

  // Идущий фоновый прогон кабинета или итог недавнего ручного; `null` —
  // слушать нечего. Ход — `followSyncMarketplaceAccount`.
  syncJob: (accountId: number) =>
    http
      .get<import('./types').MarketplaceSyncJobOut | null>(
        `/marketplaces/accounts/${accountId}/sync/job`,
      )
      .then((r) => r.data),

  // ---- карточки ----

  listings: (
    accountId: number,
    params: {
      status?: string
      search?: string
      limit?: number
      offset?: number
    } = {},
  ) =>
    http
      .get<import('./types').MarketplaceListingListOut>(
        `/marketplaces/accounts/${accountId}/listings`,
        { params },
      )
      .then((r) => r.data),

  createListings: (accountId: number, planIds: number[]) =>
    http
      .post<import('./types').MarketplaceListingsCreateOut>(
        `/marketplaces/accounts/${accountId}/listings`,
        { plan_ids: planIds },
      )
      .then((r) => r.data),

  /**
   * Остаток пачке вариантов. `quantity: null` — «как у кабинета».
   *
   * На площадку число уедет прогоном: остаток передаёт синхронизация, а
   * не эта ручка.
   */
  setListingsStock: (
    accountId: number,
    listingIds: number[],
    quantity: number | null,
  ) =>
    http
      .post<import('./types').MarketplaceListingStockOut>(
        `/marketplaces/accounts/${accountId}/listings/stock`,
        { listing_ids: listingIds, quantity },
      )
      .then((r) => r.data),

  planCandidates: (
    accountId: number,
    params: {
      search?: string
      only_sellable?: boolean
      limit?: number
      offset?: number
    } = {},
  ) =>
    http
      .get<import('./types').MarketplacePlanCandidateListOut>(
        `/marketplaces/accounts/${accountId}/plans`,
        { params },
      )
      .then((r) => r.data),

  updateListing: (
    listingId: number,
    data: import('./types').MarketplaceListingUpdate,
  ) =>
    http
      .patch<import('./types').MarketplaceListingOut>(
        `/marketplaces/listings/${listingId}`,
        data,
      )
      .then((r) => r.data),

  // `quiet` глушит глобальный тост ошибки: групповое действие проходит
  // по десяткам вариантов, и отказ по каждому непродаваемому тарифу
  // засыпал бы экран одинаковыми красными плашками. Вызывающий код
  // собирает отказы сам и показывает один итог.
  listingAction: (
    listingId: number,
    action: import('./types').MarketplaceListingAction,
    opts: { quiet?: boolean } = {},
  ) =>
    http
      .post<import('./types').MarketplaceListingOut>(
        `/marketplaces/listings/${listingId}/action`,
        { action },
        { skipErrorToast: opts.quiet === true },
      )
      .then((r) => r.data),

  deleteListing: (listingId: number) =>
    http.delete(`/marketplaces/listings/${listingId}`),

  listingEvents: (listingId: number, params: { limit?: number } = {}) =>
    http
      .get<import('./types').MarketplaceListingEventListOut>(
        `/marketplaces/listings/${listingId}/events`,
        { params },
      )
      .then((r) => r.data),

  // ---- пункты назначения и карточки с вариациями ----

  destinations: (accountId: number) =>
    http
      .get<import('./types').MarketplaceDestinationListOut>(
        `/marketplaces/accounts/${accountId}/destinations`,
      )
      .then((r) => r.data),

  cards: (accountId: number) =>
    http
      .get<import('./types').MarketplaceCardListOut>(
        `/marketplaces/accounts/${accountId}/cards`,
      )
      .then((r) => r.data),

  previewCard: (
    accountId: number,
    data: import('./types').MarketplaceCardPreviewIn,
  ) =>
    http
      .post<import('./types').MarketplaceCardPreviewOut>(
        `/marketplaces/accounts/${accountId}/cards/preview`,
        data,
      )
      .then((r) => r.data),

  saveCard: (
    accountId: number,
    data: import('./types').MarketplaceCardCreateIn,
  ) =>
    http
      .post<import('./types').MarketplaceCardSaveOut>(
        `/marketplaces/accounts/${accountId}/cards`,
        data,
      )
      .then((r) => r.data),

  card: (cardId: number) =>
    http
      .get<import('./types').MarketplaceCardOut>(
        `/marketplaces/cards/${cardId}`,
      )
      .then((r) => r.data),

  deleteCard: (cardId: number) =>
    http.delete(`/marketplaces/cards/${cardId}`),

  publishCard: (
    cardId: number,
    data: import('./types').MarketplaceCardPublishIn = {},
  ) =>
    http
      .post<import('./types').MarketplaceCardPublishOut>(
        `/marketplaces/cards/${cardId}/publish`,
        data,
        { timeout: 300_000 },
      )
      .then((r) => r.data),

  /**
   * Выложить набор карточек одним запросом.
   *
   * Ходит в сеть синхронно, поэтому вызывающий шлёт набор порциями и
   * рисует прогресс: сотня стран за один запрос — это минуты молчания и
   * обрыв по таймауту на середине.
   */
  publishCards: (
    accountId: number,
    data: import('./types').MarketplaceCardsPublishIn,
  ) =>
    http
      .post<import('./types').MarketplaceCardsPublishOut>(
        `/marketplaces/accounts/${accountId}/cards/publish`,
        data,
        { timeout: 300_000 },
      )
      .then((r) => r.data),

  // ---- сверка каталога площадки с админкой ----
  //
  // Ручки одни на все площадки: реализацию выбирает бэкенд по коду
  // маркетплейса. Здесь площадка не упоминается намеренно — иначе SPA
  // пришлось бы держать таблицу «код → путь», и она разъезжалась бы с
  // бэкендом.

  catalogImportPreview: (
    accountId: number,
    params: { photo_card_template_id?: number } = {},
  ) =>
    http
      .get<import('./types').CatalogImportPreviewOut>(
        `/marketplaces/accounts/${accountId}/catalog/import`,
        { params, timeout: 300_000 },
      )
      .then((r) => r.data),

  catalogImportApply: (
    accountId: number,
    data: import('./types').CatalogImportApplyIn,
  ) =>
    http
      .post<import('./types').CatalogImportApplyOut>(
        `/marketplaces/accounts/${accountId}/catalog/import`,
        data,
        { timeout: 300_000 },
      )
      .then((r) => r.data),

  // Односторонняя сверка: каталог площадки — источник правды. Вызывается
  // дважды — сперва с `dry_run`, чтобы показать, что исчезнет.
  catalogFullSync: (
    accountId: number,
    data: import('./types').CatalogFullSyncIn = {},
  ) =>
    http
      .post<import('./types').CatalogFullSyncOut>(
        `/marketplaces/accounts/${accountId}/catalog/full-sync`,
        data,
        { timeout: 600_000 },
      )
      .then((r) => r.data),

  // ---- шаблоны названий ----

  titleTemplate: (accountId: number) =>
    http
      .get<import('./types').MarketplaceTitleTemplateOut>(
        `/marketplaces/accounts/${accountId}/title-template`,
      )
      .then((r) => r.data),

  saveTitleTemplate: (
    accountId: number,
    data: import('./types').MarketplaceTitleTemplateIn,
  ) =>
    http
      .put<import('./types').MarketplaceTitleTemplateOut>(
        `/marketplaces/accounts/${accountId}/title-template`,
        data,
      )
      .then((r) => r.data),

  previewTitleTemplate: (
    accountId: number,
    data: import('./types').MarketplaceTitlePreviewIn,
  ) =>
    http
      .post<import('./types').MarketplaceTitlePreviewOut>(
        `/marketplaces/accounts/${accountId}/title-template/preview`,
        data,
      )
      .then((r) => r.data),

  // ---- инструкции покупателю ----
  //
  // Сами шаблоны — в `instructionsApi` («Маркетплейсы → Редактор
  // инструкций»). Здесь только выбор кабинета: какой шаблон уезжает в
  // какое место отправки.

  instructions: (accountId: number) =>
    http
      .get<import('./types').MarketplaceInstructionsOut>(
        `/marketplaces/accounts/${accountId}/instructions`,
      )
      .then((r) => r.data),

  saveInstructions: (
    accountId: number,
    data: import('./types').MarketplaceInstructionsIn,
  ) =>
    http
      .put<import('./types').MarketplaceInstructionsOut>(
        `/marketplaces/accounts/${accountId}/instructions`,
        data,
      )
      .then((r) => r.data),

  // ---- скрипты ----

  parseAndHide: (
    accountId: number,
    data: import('./types').MarketplaceParseAndHideIn,
  ) =>
    http
      .post<import('./types').MarketplaceParseAndHideOut>(
        `/marketplaces/accounts/${accountId}/scripts/parse-and-hide`,
        data,
        { timeout: 300_000 },
      )
      .then((r) => r.data),

  retitle: (accountId: number, data: import('./types').MarketplaceRetitleIn) =>
    http
      .post<import('./types').MarketplaceRetitleOut>(
        `/marketplaces/accounts/${accountId}/scripts/retitle`,
        data,
        { timeout: 600_000 },
      )
      .then((r) => r.data),

  // Наценка всему кабинету одним процентом. Как и зачёркнутая цена, в
  // сеть не ходит: пишет правило кабинета и будит раннер, а цену на
  // площадку отправит шаг цены в прогоне.
  markup: (accountId: number, data: import('./types').MarketplaceMarkupIn) =>
    http
      .post<import('./types').MarketplaceMarkupOut>(
        `/marketplaces/accounts/${accountId}/scripts/markup`,
        data,
      )
      .then((r) => r.data),

  // Зачёркнутая цена всему кабинету одним процентом. В сеть ручка не
  // ходит — только считает и сохраняет правило, — поэтому обычный
  // таймаут: площадке зачёркнутую цену отправит шаг цены в прогоне.
  discountBase: (
    accountId: number,
    data: import('./types').MarketplaceDiscountBaseIn,
  ) =>
    http
      .post<import('./types').MarketplaceDiscountBaseOut>(
        `/marketplaces/accounts/${accountId}/scripts/discount-base`,
        data,
      )
      .then((r) => r.data),

  // Догрузка картинок, добавленных в шаблон. Таймаут как у
  // переименования: ручка читает весь каталог площадки постранично.
  refreshImages: (
    accountId: number,
    data: import('./types').MarketplaceRefreshImagesIn,
  ) =>
    http
      .post<import('./types').MarketplaceRefreshImagesOut>(
        `/marketplaces/accounts/${accountId}/scripts/refresh-images`,
        data,
        { timeout: 600_000 },
      )
      .then((r) => r.data),

  // ---- коды активации ----

  webhook: (accountId: number) =>
    http
      .get<import('./types').MarketplaceWebhookOut>(
        `/marketplaces/accounts/${accountId}/webhook`,
      )
      .then((r) => r.data),

  codes: (
    accountId: number,
    params: {
      status?: string
      search?: string
      limit?: number
      offset?: number
    } = {},
  ) =>
    http
      .get<import('./types').MarketplaceActivationCodeListOut>(
        `/marketplaces/accounts/${accountId}/codes`,
        { params },
      )
      .then((r) => r.data),

  // Расшифровка одного кода. POST, потому что действие пишется в аудит,
  // и вызывать его надо по кнопке, а не при отрисовке списка.
  revealCode: (codeId: number) =>
    http
      .post<import('./types').MarketplaceActivationCodeRevealOut>(
        `/marketplaces/codes/${codeId}/reveal`,
      )
      .then((r) => r.data),

  cancelCode: (codeId: number, reason: string) =>
    http
      .post<import('./types').MarketplaceActivationCodeOut>(
        `/marketplaces/codes/${codeId}/cancel`,
        { reason },
      )
      .then((r) => r.data),

  // Ручной дубль вебхука. Ходит в сеть синхронно: у Яндекса 30 минут на
  // выдачу кода, и админ должен увидеть результат сейчас.
  deliverOrder: (accountId: number, orderId: string) =>
    http
      .post<import('./types').MarketplaceOrderDeliverOut>(
        `/marketplaces/accounts/${accountId}/orders/deliver`,
        { order_id: orderId },
        { timeout: 120_000 },
      )
      .then((r) => r.data),

  // Сверка сумм продаж с ценами в заказах площадки. `apply: false` —
  // только предпросмотр: исправление меняет выручку задним числом.
  // Ходит в сеть синхронно, пачками заказов.
  syncCodePrices: (accountId: number, body: { apply: boolean; days: number }) =>
    http
      .post<import('./types').MarketplaceSalePriceSyncOut>(
        `/marketplaces/accounts/${accountId}/codes/sync-prices`,
        body,
        { timeout: 300_000 },
      )
      .then((r) => r.data),

  // Опрос оплаченных сделок у площадок без уведомлений (Playerok).
  orderPoll: (accountId: number) =>
    http
      .get<import('./types').MarketplaceOrderPoll>(
        `/marketplaces/accounts/${accountId}/orders/poll`,
      )
      .then((r) => r.data),
  runOrderPoll: (accountId: number) =>
    http
      .post<import('./types').MarketplaceOrderPoll>(
        `/marketplaces/accounts/${accountId}/orders/poll`,
        undefined,
        { timeout: 120_000 },
      )
      .then((r) => r.data),

  // ---- пул кодов (площадки, которые раздают коды сами) ----

  // Без сети: числа наши. Расхождение с витриной площадки тут не баг —
  // сколько именно доливать, решает `topUpCodePool` по ответу площадки.
  codePool: (accountId: number) =>
    http
      .get<import('./types').MarketplaceCodePoolOut>(
        `/marketplaces/accounts/${accountId}/codes/pool`,
      )
      .then((r) => r.data),

  // Долив по кнопке — ozon-овский аналог `deliverOrder`: там админ
  // добивает зависший заказ, здесь не ждёт прогона раннера, когда пул
  // просел, а товар нужен на витрине сейчас. Ходит в сеть синхронно.
  topUpCodePool: (accountId: number) =>
    http
      .post<import('./types').MarketplaceCodePoolTopUpOut>(
        `/marketplaces/accounts/${accountId}/codes/top-up`,
        {},
        { timeout: 300_000 },
      )
      .then((r) => r.data),

  // ---- статистика активации и напоминания (коды под заказ) ----

  codeStats: (accountId: number) =>
    http
      .get<import('./types').MarketplaceCodeStatsOut>(
        `/marketplaces/accounts/${accountId}/codes/stats`,
      )
      .then((r) => r.data),

  codeReminders: (accountId: number) =>
    http
      .get<import('./types').MarketplaceCodeReminderSettingsOut>(
        `/marketplaces/accounts/${accountId}/codes/reminders`,
      )
      .then((r) => r.data),

  saveCodeReminders: (
    accountId: number,
    data: import('./types').MarketplaceCodeReminderSettingsIn,
  ) =>
    http
      .put<import('./types').MarketplaceCodeReminderSettingsOut>(
        `/marketplaces/accounts/${accountId}/codes/reminders`,
        data,
      )
      .then((r) => r.data),

  // dryRun=true — «кому ушло бы», ничего не шлёт. false — «Отправить
  // сейчас»: ходит в площадку и SMTP синхронно, отсюда длинный таймаут.
  runCodeReminders: (accountId: number, dryRun: boolean) =>
    http
      .post<import('./types').MarketplaceCodeReminderRunOut>(
        `/marketplaces/accounts/${accountId}/codes/reminders/run`,
        {},
        { params: { dry_run: dryRun }, timeout: 300_000 },
      )
      .then((r) => r.data),

  codeReminderLog: (accountId: number, limit = 50) =>
    http
      .get<import('./types').MarketplaceCodeReminderLogOut>(
        `/marketplaces/accounts/${accountId}/codes/reminders/log`,
        { params: { limit } },
      )
      .then((r) => r.data),

  // ---- аудит чатов Яндекс Маркета → поддержка ----

  // Без сети: сбои, застрявшие сообщения и настройки — всё из БД.
  chatAudit: (
    accountId: number,
    params: {
      direction?: 'inbound' | 'outbound' | 'all'
      unresolved_only?: boolean
      limit?: number
    } = {},
  ) =>
    http
      .get<import('./types').MarketplaceChatAuditOut>(
        `/marketplaces/accounts/${accountId}/chat-audit`,
        { params },
      )
      .then((r) => r.data),

  // Один запрос к Маркету: пускает ли он ключ кабинета к чатам.
  probeChatAccess: (accountId: number) =>
    http
      .post<import('./types').MarketplaceChatProbeOut>(
        `/marketplaces/accounts/${accountId}/chat-audit/probe`,
        {},
        { timeout: 60_000 },
      )
      .then((r) => r.data),
}

interface MarketplaceSyncStreamOpts {
  token: string | null
  onEvent: (e: import('./types').MarketplaceSyncEvent) => void
  signal?: AbortSignal
}

/**
 * Запустить прогон кабинета в фоне и слушать его ход (NDJSON).
 *
 * То же, что `marketplacesApi.sync`, но события приходят по ходу дела:
 * прогон трёх сотен карточек — это три сотни запросов к площадке, и
 * молчащая минуту кнопка неотличима от зависшей.
 *
 * Через `fetch`, а не axios: тому нужен целый ответ, а нам нужны строки
 * по мере поступления. Тот же приём, что у `streamParsePlans`.
 *
 * Прогон фоновый: обрыв соединения и закрытая вкладка его не отменяют,
 * а если кабинет уже синхронизируется, ответ подключается к идущему
 * прогону, а не запускает второй. Поэтому `signal` здесь значит
 * «перестать слушать», а не «отменить работу».
 *
 * `card` — прогнать одну карточку (тарифы одного назначения), а не весь
 * кабинет. Идёт прогон другого охвата — ответ 409 с объяснением.
 */
export function streamSyncMarketplaceAccount(
  accountId: number,
  opts: MarketplaceSyncStreamOpts,
  card?: { kind: string; code: string },
): Promise<void> {
  const query = card
    ? `?${new URLSearchParams({ kind: card.kind, code: card.code })}`
    : ''
  return readMarketplaceSyncStream(
    `${baseURL}/marketplaces/accounts/${accountId}/sync/stream${query}`,
    'POST',
    opts,
  )
}

/**
 * Подключиться к фоновому прогону, запущенному раньше (с закрытой
 * вкладки или раннером), — ход приходит с самого начала. Есть ли что
 * слушать, говорит `marketplacesApi.syncJob`.
 */
export function followSyncMarketplaceAccount(
  accountId: number,
  opts: MarketplaceSyncStreamOpts,
): Promise<void> {
  return readMarketplaceSyncStream(
    `${baseURL}/marketplaces/accounts/${accountId}/sync/events`,
    'GET',
    opts,
  )
}

async function readMarketplaceSyncStream(
  url: string,
  method: 'GET' | 'POST',
  opts: MarketplaceSyncStreamOpts,
): Promise<void> {
  const headers: Record<string, string> = {
    Accept: 'application/x-ndjson',
  }
  if (opts.token) headers.Authorization = `Bearer ${opts.token}`

  const res = await fetch(url, { method, headers, signal: opts.signal })
  if (!res.ok || !res.body) {
    let detail = res.statusText
    try {
      const data = await res.json()
      if (typeof data?.detail === 'string') detail = data.detail
      else if (Array.isArray(data?.detail))
        detail = data.detail
          .map((d: any) => `${(d.loc ?? []).slice(1).join('.')}: ${d.msg}`)
          .join('\n')
    } catch {
      /* ignore */
    }
    throw new Error(`${res.status} ${detail}`)
  }

  const reader = res.body.getReader()
  const decoder = new TextDecoder('utf-8')
  let buffer = ''
  for (;;) {
    const { done, value } = await reader.read()
    if (done) break
    buffer += decoder.decode(value, { stream: true })
    let nl: number
    while ((nl = buffer.indexOf('\n')) >= 0) {
      const line = buffer.slice(0, nl).trim()
      buffer = buffer.slice(nl + 1)
      if (!line) continue
      try {
        opts.onEvent(JSON.parse(line) as import('./types').MarketplaceSyncEvent)
      } catch (e) {
        console.warn('marketplace-sync-stream: bad NDJSON line', line, e)
      }
    }
  }
  const tail = buffer.trim()
  if (tail) {
    try {
      opts.onEvent(JSON.parse(tail) as import('./types').MarketplaceSyncEvent)
    } catch {
      /* ignore */
    }
  }
}

/**
 * «Маркетплейсы → Редактор фото-карточек».
 *
 * Медиа (миниатюры, картинки, шрифты) отдаётся ТОЛЬКО с токеном админа:
 * публичных ссылок у раздела нет. Поэтому картинки нельзя подставить в
 * `<img src>` напрямую — их тянут `*Blob`-методами и оборачивают в
 * `URL.createObjectURL`. Служебное неудобство, зато макеты и фирменные
 * шрифты не утекают по прямой ссылке из истории браузера или логов.
 */
export const photoCardsApi = {
  meta: () =>
    http
      .get<import('./types').PhotoCardMetaOut>('/photo-cards/meta')
      .then((r) => r.data),

  // ---- шаблоны ----

  templates: () =>
    http
      .get<import('./types').PhotoCardTemplateListOut>('/photo-cards/templates')
      .then((r) => r.data),

  template: (templateId: number) =>
    http
      .get<import('./types').PhotoCardTemplateOut>(
        `/photo-cards/templates/${templateId}`,
      )
      .then((r) => r.data),

  createTemplate: (data: import('./types').PhotoCardTemplateCreate) =>
    http
      .post<import('./types').PhotoCardTemplateOut>('/photo-cards/templates', data)
      .then((r) => r.data),

  updateTemplate: (
    templateId: number,
    data: import('./types').PhotoCardTemplateUpdate,
  ) =>
    http
      .patch<import('./types').PhotoCardTemplateOut>(
        `/photo-cards/templates/${templateId}`,
        data,
      )
      .then((r) => r.data),

  duplicateTemplate: (templateId: number) =>
    http
      .post<import('./types').PhotoCardTemplateOut>(
        `/photo-cards/templates/${templateId}/duplicate`,
      )
      .then((r) => r.data),

  deleteTemplate: (templateId: number) =>
    http.delete(`/photo-cards/templates/${templateId}`),

  /** Миниатюра для списка. Кэш живёт на сервере, здесь только байты. */
  previewBlob: (templateId: number) =>
    http
      .get<Blob>(`/photo-cards/templates/${templateId}/preview`, {
        responseType: 'blob',
      })
      .then((r) => r.data),

  /** Полноразмерная карточка сохранённого шаблона — та же, что уедет на площадку. */
  renderTemplateBlob: (
    templateId: number,
    params: {
      plan_id?: number
      page?: number
      scale?: number
      format?: 'png' | 'jpeg' | 'webp'
    } = {},
  ) =>
    http
      .get<Blob>(`/photo-cards/templates/${templateId}/render`, {
        params,
        responseType: 'blob',
        timeout: 60_000,
      })
      .then((r) => r.data),

  /** Точный предпросмотр НЕсохранённого документа: сверка DOM-макета с Pillow. */
  render: (data: import('./types').PhotoCardRenderIn) =>
    http
      .post<import('./types').PhotoCardRenderOut>('/photo-cards/render', data, {
        timeout: 60_000,
      })
      .then((r) => r.data),

  // ---- картинки ----

  assets: (params: { kind?: 'image' | 'flag'; pack?: string } = {}) =>
    http
      .get<import('./types').PhotoCardAssetListOut>('/photo-cards/assets', {
        params,
      })
      .then((r) => r.data),

  /** Пачкой: флаги заливают папкой, ISO-код читается из имени файла. */
  uploadAssets: (
    files: File[],
    options: { kind?: 'image' | 'flag'; pack?: string; code?: string } = {},
  ) => {
    const fd = new FormData()
    for (const file of files) fd.append('files', file)
    if (options.kind) fd.append('kind', options.kind)
    if (options.pack) fd.append('pack', options.pack)
    if (options.code) fd.append('code', options.code)
    return http
      .post<import('./types').PhotoCardUploadOut>('/photo-cards/assets', fd, {
        timeout: 180_000,
        headers: { 'Content-Type': false as unknown as string },
      })
      .then((r) => r.data)
  },

  assetBlob: (assetId: number) =>
    http
      .get<Blob>(`/photo-cards/assets/${assetId}/file`, { responseType: 'blob' })
      .then((r) => r.data),

  /**
   * Флаг по коду. Ходит по той же цепочке «кастомный пак → встроенный»,
   * что и рендер: холст обязан показывать ровно тот флаг, который
   * окажется в готовой карточке.
   */
  flagBlob: (pack: string, code: string) =>
    http
      .get<Blob>(
        `/photo-cards/flags/${encodeURIComponent(pack)}/${encodeURIComponent(code)}`,
        { responseType: 'blob', skipErrorToast: true },
      )
      .then((r) => r.data),

  deleteAsset: (assetId: number) => http.delete(`/photo-cards/assets/${assetId}`),

  // ---- шрифты ----

  fonts: () =>
    http
      .get<import('./types').PhotoCardFontListOut>('/photo-cards/fonts')
      .then((r) => r.data),

  uploadFont: (
    file: File,
    options: { family?: string; weight?: number; italic?: boolean } = {},
  ) => {
    const fd = new FormData()
    fd.append('file', file)
    if (options.family) fd.append('family', options.family)
    if (options.weight != null) fd.append('weight', String(options.weight))
    if (options.italic != null) fd.append('italic', String(options.italic))
    return http
      .post<import('./types').PhotoCardFontOut>('/photo-cards/fonts', fd, {
        timeout: 120_000,
        headers: { 'Content-Type': false as unknown as string },
      })
      .then((r) => r.data)
  },

  /** Файл для `@font-face`: браузер и Pillow обязаны рисовать одним файлом. */
  fontBlob: (ref: string) =>
    http
      .get<Blob>(`/photo-cards/fonts/${encodeURIComponent(ref)}/file`, {
        responseType: 'blob',
      })
      .then((r) => r.data),

  deleteFont: (fontId: number) => http.delete(`/photo-cards/fonts/${fontId}`),

  // ---- тарифы-образцы ----

  plans: (params: { q?: string; limit?: number } = {}) =>
    http
      .get<import('./types').PhotoCardPlanSampleListOut>('/photo-cards/plans', {
        params,
      })
      .then((r) => r.data),
}

/**
 * «Маркетплейсы → Редактор инструкций».
 *
 * Текст, который покупатель цифрового товара получает от площадки
 * вместе с кодом активации: письмо, описание товара, сообщение в чат.
 *
 * Предпросмотр считается на сервере, а не в браузере: чистка HTML и
 * разворот разметки в плоский текст — это ровно то, что уедет
 * площадке, и вторая реализация тех же правил на TypeScript
 * разошлась бы с первой на первом же нестандартном теге.
 *
 * Назначение шаблона на место отправки живёт в `marketplacesApi`: это
 * настройка кабинета, а не свойство шаблона.
 */
export const instructionsApi = {
  meta: () =>
    http
      .get<import('./types').InstructionMetaOut>('/instructions/meta')
      .then((r) => r.data),

  templates: (params: { only_active?: boolean } = {}) =>
    http
      .get<import('./types').InstructionTemplateListOut>(
        '/instructions/templates',
        { params },
      )
      .then((r) => r.data),

  template: (templateId: number) =>
    http
      .get<import('./types').InstructionTemplateOut>(
        `/instructions/templates/${templateId}`,
      )
      .then((r) => r.data),

  createTemplate: (data: import('./types').InstructionTemplateCreate) =>
    http
      .post<import('./types').InstructionTemplateOut>(
        '/instructions/templates',
        data,
      )
      .then((r) => r.data),

  updateTemplate: (
    templateId: number,
    data: import('./types').InstructionTemplateUpdate,
  ) =>
    http
      .patch<import('./types').InstructionTemplateOut>(
        `/instructions/templates/${templateId}`,
        data,
      )
      .then((r) => r.data),

  duplicateTemplate: (templateId: number) =>
    http
      .post<import('./types').InstructionTemplateOut>(
        `/instructions/templates/${templateId}/duplicate`,
      )
      .then((r) => r.data),

  deleteTemplate: (templateId: number) =>
    http.delete(`/instructions/templates/${templateId}`),

  /** Как НЕсохранённый шаблон выглядит в каждом месте отправки. */
  preview: (data: import('./types').InstructionPreviewIn) =>
    http
      .post<import('./types').InstructionPreviewOut>(
        '/instructions/preview',
        data,
      )
      .then((r) => r.data),
}

// ---- ПРОКСИ (реестр прокси-серверов) -----------------------------------
//
// Раздел «Прокси» в группе «SMS»: через эти адреса кабинеты агрегаторов
// ходят к своим API. Секреты (пароль, CA-сертификат) наружу не отдаются —
// в ответах только `masked_url` и флаги `has_password` / `has_ca_cert`.
// Отсюда правило форм: пустое поле пароля = «не менять», пустая строка =
// «убрать». Бэкенд — api/admin/routers/proxies.py.

export const proxyApi = {
  /** `onlyActive` — для выпадашки в редакторе кабинета. */
  list: (onlyActive = false) =>
    http
      .get<import('./types').ProxyServerOut[]>('/proxies/', {
        params: onlyActive ? { only_active: true } : undefined,
      })
      .then((r) => r.data),
  create: (data: import('./types').ProxyServerCreate) =>
    http
      .post<import('./types').ProxyServerOut>('/proxies/', data)
      .then((r) => r.data),
  update: (id: number, data: import('./types').ProxyServerUpdate) =>
    http
      .patch<import('./types').ProxyServerOut>(`/proxies/${id}`, data)
      .then((r) => r.data),
  /**
   * По умолчанию — выключить (убрать из выпадашки новых кабинетов, уже
   * настроенные продолжат ходить). `hard=true` удаляет строку и отвечает
   * 409, если прокси занят кабинетами.
   */
  remove: (id: number, hard = false) =>
    http.delete(`/proxies/${id}`, { params: { hard } }),
  /** Кто ходит через прокси — для подтверждения удаления. */
  usage: (id: number) =>
    http
      .get<import('./types').ProxyUsageOut>(`/proxies/${id}/usage`)
      .then((r) => r.data),
  /**
   * Сходить через прокси в интернет. Провал приезжает как `ok: false` с
   * HTTP 200 — показывать его надо строкой с причиной, а не тостом
   * «ошибка сервера».
   */
  check: (id: number, data: import('./types').ProxyCheckIn = {}) =>
    http
      .post<import('./types').ProxyCheckOut>(`/proxies/${id}/check`, data)
      .then((r) => r.data),
  /**
   * Настройки ретранслятора глазами СЕРВЕРА АДМИНКИ плюс разбор
   * транспорта по каждому кабинету. Разные серверы — разные `.env`, и
   * заполненные здесь переменные ничего не говорят про клиентское API.
   */
  relayStatus: () =>
    http
      .get<import('./types').SmsRelayStatusOut>('/proxies/relay')
      .then((r) => r.data),
  /**
   * Живая проверка: `/health` ретранслятора, затем запрос к агрегатору с
   * заведомо неверным ключом. Провал — это `ok: false` с HTTP 200.
   */
  relayCheck: (data: import('./types').SmsRelayCheckIn = {}) =>
    http
      .post<import('./types').SmsRelayCheckOut>('/proxies/relay/check', data)
      .then((r) => r.data),
}

// ---- SMS SENDER (одноразовые номера для приёма чужих кодов) -------------
//
// Группа «SMS» в меню админки — три раздела и один домен:
//
//   * «SMS провайдеры» (`/sms-senders/*`) — агрегаторы, наши кабинеты у
//     них, глобальная наценка и вкладка «Активации» для саппорта;
//   * «SMS страны»     (`/sms-countries/*`);
//   * «SMS сервисы»    (`/sms-services/*`).
//
// Не путать с `smsApi` выше — там раздел «SMS-уведомления»: ИСХОДЯЩИЕ
// коды подтверждения нашим клиентам. Общего кода у них нет.
//
// Три отдельных префикса, потому что раздел-уровневый доступ на бэкенде
// определяется префиксом роутера (см. `_SECTION_BY_PREFIX` в
// api/admin/main.py): один префикс — один ключ раздела.

export const smsSenderApi = {
  // ----- агрегаторы -----
  /** Коды, под которые в бэкенде есть адаптер (для выпадашки «Код»). */
  supportedCodes: () =>
    http
      .get<import('./types').SupportedSmsSender[]>('/sms-senders/supported-codes')
      .then((r) => r.data),

  listProviders: () =>
    http
      .get<import('./types').SmsSenderProviderOut[]>('/sms-senders/providers')
      .then((r) => r.data),
  createProvider: (data: import('./types').SmsSenderProviderCreate) =>
    http
      .post<import('./types').SmsSenderProviderOut>('/sms-senders/providers', data)
      .then((r) => r.data),
  updateProvider: (
    id: number,
    data: import('./types').SmsSenderProviderUpdate,
  ) =>
    http
      .patch<import('./types').SmsSenderProviderOut>(
        `/sms-senders/providers/${id}`,
        data,
      )
      .then((r) => r.data),
  /** `hard=true` запрещён, пока на агрегаторе висят активации. */
  deleteProvider: (id: number, hard = false) =>
    http.delete(`/sms-senders/providers/${id}`, { params: { hard } }),

  // ----- кабинеты -----
  listAccounts: (providerId?: number) =>
    http
      .get<import('./types').SmsSenderAccountOut[]>('/sms-senders/accounts', {
        params: providerId ? { provider_id: providerId } : undefined,
      })
      .then((r) => r.data),
  createAccount: (data: import('./types').SmsSenderAccountCreate) =>
    http
      .post<import('./types').SmsSenderAccountOut>('/sms-senders/accounts', data)
      .then((r) => r.data),
  updateAccount: (id: number, data: import('./types').SmsSenderAccountUpdate) =>
    http
      .patch<import('./types').SmsSenderAccountOut>(
        `/sms-senders/accounts/${id}`,
        data,
      )
      .then((r) => r.data),
  deleteAccount: (id: number, hard = false) =>
    http.delete(`/sms-senders/accounts/${id}`, { params: { hard } }),
  /** Спросить баланс у агрегатора. Заодно проверяет, живой ли ключ. */
  syncAccountBalance: (id: number) =>
    http
      .post<import('./types').SmsSenderBalanceOut>(
        `/sms-senders/accounts/${id}/sync-balance`,
      )
      .then((r) => r.data),

  // ----- наценка -----
  getMarkup: () =>
    http
      .get<import('./types').SmsSenderMarkupOut>('/sms-senders/markup')
      .then((r) => r.data),
  updateMarkup: (data: import('./types').SmsSenderMarkupUpdate) =>
    http
      .put<import('./types').SmsSenderMarkupOut>('/sms-senders/markup', data)
      .then((r) => r.data),

  // ----- активации (вкладка саппорта) -----
  listActivations: (params: import('./types').SmsSenderActivationsParams = {}) =>
    http
      .get<import('./types').SmsSenderActivationListOut>(
        '/sms-senders/activations',
        { params },
      )
      .then((r) => r.data),
  getActivation: (id: number) =>
    http
      .get<import('./types').SmsSenderActivationOut>(
        `/sms-senders/activations/${id}`,
      )
      .then((r) => r.data),

  // ----- страны -----
  listCountries: (providerId?: number) =>
    http
      .get<import('./types').SmsSenderCountryOut[]>('/sms-countries/', {
        params: providerId ? { provider_id: providerId } : undefined,
      })
      .then((r) => r.data),
  /** Апсерт из API агрегатора: ручные настройки не затираются. */
  syncCountries: (providerId: number) =>
    http
      .post<import('./types').SmsSenderSyncOut>('/sms-countries/sync', null, {
        params: { provider_id: providerId },
      })
      .then((r) => r.data),
  updateCountry: (id: number, data: import('./types').SmsSenderCountryUpdate) =>
    http
      .patch<import('./types').SmsSenderCountryOut>(`/sms-countries/${id}`, data)
      .then((r) => r.data),
  setCountriesVisibility: (data: import('./types').SmsSenderVisibilityBulkIn) =>
    http
      .post<import('./types').SmsSenderSyncOut>('/sms-countries/visibility', data)
      .then((r) => r.data),

  // ----- сервисы -----
  listServices: (params: {
    provider_id?: number
    only_visible?: boolean
    search?: string
    limit?: number
    offset?: number
  } = {}) =>
    http
      .get<import('./types').SmsSenderServiceListOut>('/sms-services/', { params })
      .then((r) => r.data),
  /** Новые сервисы приезжают СКРЫТЫМИ — витрину собирает админ. */
  syncServices: (providerId: number) =>
    http
      .post<import('./types').SmsSenderSyncOut>('/sms-services/sync', null, {
        params: { provider_id: providerId },
      })
      .then((r) => r.data),
  updateService: (id: number, data: import('./types').SmsSenderServiceUpdate) =>
    http
      .patch<import('./types').SmsSenderServiceOut>(`/sms-services/${id}`, data)
      .then((r) => r.data),
  setServicesVisibility: (data: import('./types').SmsSenderVisibilityBulkIn) =>
    http
      .post<import('./types').SmsSenderSyncOut>('/sms-services/visibility', data)
      .then((r) => r.data),
}

// «Партнёрская программа» — api/admin/routers/partner_program.py.
// Показ реквизитов — POST: каждый вызов пишется в аудит.
export const partnerProgramApi = {
  listPartners: (params: import('./types').AdminPartnerListParams = {}) =>
    http
      .get<import('./types').AdminPartnerListOut>('/partner-program/partners', { params })
      .then((r) => r.data),
  getPartner: (userId: number) =>
    http
      .get<import('./types').AdminPartnerDetailOut>(`/partner-program/partners/${userId}`)
      .then((r) => r.data),
  updatePartner: (userId: number, body: import('./types').AdminPartnerPatchIn) =>
    http
      .patch<import('./types').AdminPartnerDetailOut>(
        `/partner-program/partners/${userId}`,
        body,
      )
      .then((r) => r.data),
  stats: (userId: number, params: import('./types').AdminPartnerStatsParams = {}) =>
    http
      .get<import('./types').AdminPartnerStatsOut>(
        `/partner-program/partners/${userId}/stats`,
        { params },
      )
      .then((r) => r.data),
  accruals: (
    userId: number,
    params: { status?: import('./types').PartnerAccrualStatus; limit?: number; offset?: number } = {},
  ) =>
    http
      .get<import('./types').AdminPartnerAccrualListOut>(
        `/partner-program/partners/${userId}/accruals`,
        { params },
      )
      .then((r) => r.data),
  cancelAccrual: (accrualId: number, reason: string) =>
    http
      .post<import('./types').AdminPartnerAccrualCancelOut>(
        `/partner-program/accruals/${accrualId}/cancel`,
        { reason },
      )
      .then((r) => r.data),
  listPayouts: (
    params: {
      status?: import('./types').PartnerPayoutStatus
      user_id?: number
      limit?: number
      offset?: number
    } = {},
  ) =>
    http
      .get<import('./types').AdminPartnerPayoutListOut>('/partner-program/payouts', { params })
      .then((r) => r.data),
  revealRequisites: (payoutId: number) =>
    http
      .post<import('./types').AdminPartnerRequisitesOut>(
        `/partner-program/payouts/${payoutId}/requisites`,
      )
      .then((r) => r.data),
  markPaid: (payoutId: number, comment?: string) =>
    http
      .post<import('./types').AdminPartnerPayoutPaidOut>(
        `/partner-program/payouts/${payoutId}/paid`,
        { comment: comment || null },
      )
      .then((r) => r.data),
  reject: (payoutId: number, comment: string) =>
    http
      .post<import('./types').AdminPartnerPayoutOut>(
        `/partner-program/payouts/${payoutId}/reject`,
        { comment },
      )
      .then((r) => r.data),
}
